// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Css_Core = require("bs-css/src/Css_Core.bs.js");
var DomUtils = require("../../shared/src/DomUtils.bs.js");
var MathUtils = require("../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Css_AtomicTypes = require("bs-css/src/Css_AtomicTypes.bs.js");
var CommonStyleTypes = require("../../shared/src/types/CommonStyleTypes.bs.js");
var XSvg = require("../../shared/img/icons/x.svg").default;
var CarSvg = require("../../shared/img/icons/car.svg").default;
var DaySvg = require("../../shared/img/icons/day.svg").default;
var EyeSvg = require("../../shared/img/icons/eye.svg").default;
var CommonTypes_ShiftType_Category = require("../../shared/src/types/CommonTypes_ShiftType_Category.bs.js");
var BellSvg = require("../../shared/img/icons/bell.svg").default;
var BoltSvg = require("../../shared/img/icons/bolt.svg").default;
var BookSvg = require("../../shared/img/icons/book.svg").default;
var CookSvg = require("../../shared/img/icons/cook.svg").default;
var CopySvg = require("../../shared/img/icons/copy.svg").default;
var FormSvg = require("../../shared/img/icons/form.svg").default;
var HomeSvg = require("../../shared/img/icons/home.svg").default;
var InfoSvg = require("../../shared/img/icons/info.svg").default;
var LinkSvg = require("../../shared/img/icons/link.svg").default;
var ListSvg = require("../../shared/img/icons/list.svg").default;
var MailSvg = require("../../shared/img/icons/mail.svg").default;
var MenuSvg = require("../../shared/img/icons/menu.svg").default;
var MoonSvg = require("../../shared/img/icons/moon.svg").default;
var PlusSvg = require("../../shared/img/icons/plus.svg").default;
var SendSvg = require("../../shared/img/icons/send.svg").default;
var StarSvg = require("../../shared/img/icons/star.svg").default;
var TimeSvg = require("../../shared/img/icons/time.svg").default;
var DarkSvg = require("../../shared/img/logos/dark.svg").default;
var ClockSvg = require("../../shared/img/icons/clock.svg").default;
var HeartSvg = require("../../shared/img/icons/heart.svg").default;
var ImageSvg = require("../../shared/img/icons/image.svg").default;
var InboxSvg = require("../../shared/img/icons/inbox.svg").default;
var MinusSvg = require("../../shared/img/icons/minus.svg").default;
var PhoneSvg = require("../../shared/img/icons/phone.svg").default;
var ShareSvg = require("../../shared/img/icons/share.svg").default;
var ShirtSvg = require("../../shared/img/icons/shirt.svg").default;
var TrashSvg = require("../../shared/img/icons/trash.svg").default;
var UsersSvg = require("../../shared/img/icons/users.svg").default;
var LightSvg = require("../../shared/img/logos/light.svg").default;
var BlobSvg = require("../../shared/img/blobs/blob-1.svg").default;
var BlobSvg$1 = require("../../shared/img/blobs/blob-2.svg").default;
var BlobSvg$2 = require("../../shared/img/blobs/blob-3.svg").default;
var BlobSvg$3 = require("../../shared/img/blobs/blob-4.svg").default;
var BlobSvg$4 = require("../../shared/img/blobs/blob-5.svg").default;
var CameraSvg = require("../../shared/img/icons/camera.svg").default;
var DeleteSvg = require("../../shared/img/icons/delete.svg").default;
var DollarSvg = require("../../shared/img/icons/dollar.svg").default;
var EyeNoSvg = require("../../shared/img/icons/eye-no.svg").default;
var GoogleSvg = require("../../shared/img/icons/google.svg").default;
var PinNoSvg = require("../../shared/img/icons/pin-no.svg").default;
var SearchSvg = require("../../shared/img/icons/search.svg").default;
var ServerSvg = require("../../shared/img/icons/server.svg").default;
var UploadSvg = require("../../shared/img/icons/upload.svg").default;
var AtSignSvg = require("../../shared/img/icons/at-sign.svg").default;
var BehanceSvg = require("../../shared/img/icons/behance.svg").default;
var BigplusSvg = require("../../shared/img/icons/bigplus.svg").default;
var CommentSvg = require("../../shared/img/icons/comment.svg").default;
var ConfirmSvg = require("../../shared/img/icons/confirm.svg").default;
var EveningSvg = require("../../shared/img/icons/evening.svg").default;
var HashtagSvg = require("../../shared/img/icons/hashtag.svg").default;
var MatchesSvg = require("../../shared/img/icons/matches.svg").default;
var MorningSvg = require("../../shared/img/icons/morning.svg").default;
var ProfileSvg = require("../../shared/img/icons/profile.svg").default;
var QrCodeSvg = require("../../shared/img/icons/qr-code.svg").default;
var StarNoSvg = require("../../shared/img/icons/star-no.svg").default;
var TwitterSvg = require("../../shared/img/icons/twitter.svg").default;
var YoutubeSvg = require("../../shared/img/icons/youtube.svg").default;
var QwickISvg = require("../../shared/img/logos/qwick-i.svg").default;
var AddUserSvg = require("../../shared/img/icons/add-user.svg").default;
var CalendarSvg = require("../../shared/img/icons/calendar.svg").default;
var CircleXSvg = require("../../shared/img/icons/circle-x.svg").default;
var DocumentSvg = require("../../shared/img/icons/document.svg").default;
var DownloadSvg = require("../../shared/img/icons/download.svg").default;
var DribbbleSvg = require("../../shared/img/icons/dribbble.svg").default;
var FacebookSvg = require("../../shared/img/icons/facebook.svg").default;
var LinkedinSvg = require("../../shared/img/icons/linkedin.svg").default;
var LocationSvg = require("../../shared/img/icons/location.svg").default;
var MoreHorSvg = require("../../shared/img/icons/more-hor.svg").default;
var PasswordSvg = require("../../shared/img/icons/password.svg").default;
var QuestionSvg = require("../../shared/img/icons/question.svg").default;
var SettingsSvg = require("../../shared/img/icons/settings.svg").default;
var VerifiedSvg = require("../../shared/img/icons/verified.svg").default;
var ArrowTopSvg = require("../../shared/img/icons/arrow-top.svg").default;
var BartenderSvg = require("../../shared/img/icons/bartender.svg").default;
var BriefcaseSvg = require("../../shared/img/icons/briefcase.svg").default;
var CameraNoSvg = require("../../shared/img/icons/camera-no.svg").default;
var CarBlockSvg = require("../../shared/img/icons/car-block.svg").default;
var CarCheckSvg = require("../../shared/img/icons/car-check.svg").default;
var ClipboardSvg = require("../../shared/img/icons/clipboard.svg").default;
var DirectionSvg = require("../../shared/img/icons/direction.svg").default;
var GenLaborSvg = require("../../shared/img/icons/gen-labor.svg").default;
var InstagramSvg = require("../../shared/img/icons/instagram.svg").default;
var MoreVertSvg = require("../../shared/img/icons/more-vert.svg").default;
var NewspaperSvg = require("../../shared/img/icons/newspaper.svg").default;
var ThumbsUpSvg = require("../../shared/img/icons/thumbs-up.svg").default;
var TimeBackSvg = require("../../shared/img/icons/time-back.svg").default;
var AlarmLateSvg = require("../../shared/img/icons/alarm-late.svg").default;
var AlarmPlusSvg = require("../../shared/img/icons/alarm-plus.svg").default;
var ArrowLeftSvg = require("../../shared/img/icons/arrow-left.svg").default;
var CheckMarkSvg = require("../../shared/img/icons/check-mark.svg").default;
var CreditcardSvg = require("../../shared/img/icons/creditcard.svg").default;
var MicrophoneSvg = require("../../shared/img/icons/microphone.svg").default;
var ArrowRightSvg = require("../../shared/img/icons/arrow-right.svg").default;
var ChevronTopSvg = require("../../shared/img/icons/chevron-top.svg").default;
var CirclePlusSvg = require("../../shared/img/icons/circle-plus.svg").default;
var CircleStarSvg = require("../../shared/img/icons/circle-star.svg").default;
var FlagFilledSvg = require("../../shared/img/icons/flag-filled.svg").default;
var LockCircleSvg = require("../../shared/img/icons/lock-circle.svg").default;
var PencilEditSvg = require("../../shared/img/icons/pencil-edit.svg").default;
var SelectAreaSvg = require("../../shared/img/icons/select-area.svg").default;
var StarFilledSvg = require("../../shared/img/icons/star-filled.svg").default;
var LawSvg = require("../../shared/img/illustrations/law.svg").default;
var AlertCircleSvg = require("../../shared/img/icons/alert-circle.svg").default;
var ArrowBottomSvg = require("../../shared/img/icons/arrow-bottom.svg").default;
var ChevronLeftSvg = require("../../shared/img/icons/chevron-left.svg").default;
var CircleBlockSvg = require("../../shared/img/icons/circle-block.svg").default;
var CircleMinusSvg = require("../../shared/img/icons/circle-minus.svg").default;
var CommentPlusSvg = require("../../shared/img/icons/comment-plus.svg").default;
var CommentTextSvg = require("../../shared/img/icons/comment-text.svg").default;
var CrossStreetSvg = require("../../shared/img/icons/cross-street.svg").default;
var VideoCameraSvg = require("../../shared/img/icons/video-camera.svg").default;
var MaskSvg = require("../../shared/img/illustrations/mask.svg").default;
var AlarmCheckedSvg = require("../../shared/img/icons/alarm-checked.svg").default;
var AmericanFlagSvg = require("../../shared/img/icons/american-flag.svg").default;
var CalendarPlusSvg = require("../../shared/img/icons/calendar-plus.svg").default;
var CameraCreateSvg = require("../../shared/img/icons/camera-create.svg").default;
var ChevronRightSvg = require("../../shared/img/icons/chevron-right.svg").default;
var CommentMinusSvg = require("../../shared/img/icons/comment-minus.svg").default;
var PencilCreateSvg = require("../../shared/img/icons/pencil-create.svg").default;
var MiamiSvg = require("../../shared/img/illustrations/miami.svg").default;
var BusinessDarkSvg = require("../../shared/img/logos/business-dark.svg").default;
var AlertTriangleSvg = require("../../shared/img/icons/alert-triangle.svg").default;
var ArrowBoldTopSvg = require("../../shared/img/icons/arrow-bold-top.svg").default;
var CalendarDatesSvg = require("../../shared/img/icons/calendar-dates.svg").default;
var ChevronBottomSvg = require("../../shared/img/icons/chevron-bottom.svg").default;
var CircleCheckedSvg = require("../../shared/img/icons/circle-checked.svg").default;
var CommentDeleteSvg = require("../../shared/img/icons/comment-delete.svg").default;
var UniformBulletSvg = require("../../shared/img/icons/uniform-bullet.svg").default;
var AttireSvg = require("../../shared/img/illustrations/attire.svg").default;
var CameraSvg$1 = require("../../shared/img/illustrations/camera.svg").default;
var DallasSvg = require("../../shared/img/illustrations/dallas.svg").default;
var GrowthSvg = require("../../shared/img/illustrations/growth.svg").default;
var LaptopSvg = require("../../shared/img/illustrations/laptop.svg").default;
var ServerSvg$1 = require("../../shared/img/illustrations/server.svg").default;
var BusinessLightSvg = require("../../shared/img/logos/business-light.svg").default;
var BlobNegativeSvg = require("../../shared/img/blobs/blob-1-negative.svg").default;
var BlobNegativeSvg$1 = require("../../shared/img/blobs/blob-2-negative.svg").default;
var BlobNegativeSvg$2 = require("../../shared/img/blobs/blob-3-negative.svg").default;
var BlobNegativeSvg$3 = require("../../shared/img/blobs/blob-4-negative.svg").default;
var BlobNegativeSvg$4 = require("../../shared/img/blobs/blob-5-negative.svg").default;
var ArrowBoldLeftSvg = require("../../shared/img/icons/arrow-bold-left.svg").default;
var ArrowBoldRedoSvg = require("../../shared/img/icons/arrow-bold-redo.svg").default;
var ArrowBoldUndoSvg = require("../../shared/img/icons/arrow-bold-undo.svg").default;
var BrightnessHighSvg = require("../../shared/img/icons/brightness-high.svg").default;
var CircleQuestionSvg = require("../../shared/img/icons/circle-question.svg").default;
var CommentCheckedSvg = require("../../shared/img/icons/comment-checked.svg").default;
var QuestionCircleSvg = require("../../shared/img/icons/question-circle.svg").default;
var ArizonaSvg = require("../../shared/img/illustrations/arizona.svg").default;
var AtlantaSvg = require("../../shared/img/illustrations/atlanta.svg").default;
var CaAbSvg = require("../../shared/img/illustrations/ca-ab-5.svg").default;
var ChicagoSvg = require("../../shared/img/illustrations/chicago.svg").default;
var DesktopSvg = require("../../shared/img/illustrations/desktop.svg").default;
var HoustonSvg = require("../../shared/img/illustrations/houston.svg").default;
var MapPinSvg = require("../../shared/img/illustrations/map-pin.svg").default;
var NewyorkSvg = require("../../shared/img/illustrations/newyork.svg").default;
var PresentSvg = require("../../shared/img/illustrations/present.svg").default;
var TwitterSvg$1 = require("../../shared/img/illustrations/twitter.svg").default;
var ArrowBoldRightSvg = require("../../shared/img/icons/arrow-bold-right.svg").default;
var CalendarCheckedSvg = require("../../shared/img/icons/calendar-checked.svg").default;
var CannedResponsesSvg = require("../../shared/img/icons/canned-responses.svg").default;
var ChevronsUpDownSvg = require("../../shared/img/icons/chevrons-up-down.svg").default;
var CircleArrowTopSvg = require("../../shared/img/icons/circle-arrow-top.svg").default;
var MicrophoneMutedSvg = require("../../shared/img/icons/microphone-muted.svg").default;
var RotateClockwiseSvg = require("../../shared/img/icons/rotate-clockwise.svg").default;
var CongratsSvg = require("../../shared/img/illustrations/congrats.svg").default;
var FacebookSvg$1 = require("../../shared/img/illustrations/facebook.svg").default;
var FireworkSvg = require("../../shared/img/illustrations/firework.svg").default;
var IdBadgeSvg = require("../../shared/img/illustrations/id-badge.svg").default;
var KeyboardSvg = require("../../shared/img/illustrations/keyboard.svg").default;
var LinkedinSvg$1 = require("../../shared/img/illustrations/linkedin.svg").default;
var MaskRedSvg = require("../../shared/img/illustrations/mask-red.svg").default;
var MessagesSvg = require("../../shared/img/illustrations/messages.svg").default;
var PersonXSvg = require("../../shared/img/illustrations/person-x.svg").default;
var SandiegoSvg = require("../../shared/img/illustrations/sandiego.svg").default;
var ArrowBoldBottomSvg = require("../../shared/img/icons/arrow-bold-bottom.svg").default;
var CircleArrowLeftSvg = require("../../shared/img/icons/circle-arrow-left.svg").default;
var RefreshClockwiseSvg = require("../../shared/img/icons/refresh-clockwise.svg").default;
var VideoCameraPlusSvg = require("../../shared/img/icons/video-camera-plus.svg").default;
var AttentionSvg = require("../../shared/img/illustrations/attention.svg").default;
var BartenderSvg$1 = require("../../shared/img/illustrations/bartender.svg").default;
var ChecklistSvg = require("../../shared/img/illustrations/checklist.svg").default;
var CommunitySvg = require("../../shared/img/illustrations/community.svg").default;
var HandshakeSvg = require("../../shared/img/illustrations/handshake.svg").default;
var HourglassSvg = require("../../shared/img/illustrations/hourglass.svg").default;
var InstagramSvg$1 = require("../../shared/img/illustrations/instagram.svg").default;
var InterviewSvg = require("../../shared/img/illustrations/interview.svg").default;
var MeetingXSvg = require("../../shared/img/illustrations/meeting-x.svg").default;
var MoneyBagSvg = require("../../shared/img/illustrations/money-bag.svg").default;
var NewBadgeSvg = require("../../shared/img/illustrations/new-badge.svg").default;
var NewjerseySvg = require("../../shared/img/illustrations/newjersey.svg").default;
var TexasAllSvg = require("../../shared/img/illustrations/texas-all.svg").default;
var ThumbsUpSvg$1 = require("../../shared/img/illustrations/thumbs-up.svg").default;
var CircleArrowRightSvg = require("../../shared/img/icons/circle-arrow-right.svg").default;
var CircleChevronTopSvg = require("../../shared/img/icons/circle-chevron-top.svg").default;
var CreditcardSvg$1 = require("../../shared/img/illustrations/creditcard.svg").default;
var CutRibbonSvg = require("../../shared/img/illustrations/cut-ribbon.svg").default;
var HeadGearsSvg = require("../../shared/img/illustrations/head-gears.svg").default;
var MakeMovesSvg = require("../../shared/img/illustrations/make-moves.svg").default;
var PinNumberSvg = require("../../shared/img/illustrations/pin-number.svg").default;
var RecruitingSvg = require("../../shared/img/illustrations/recruiting.svg").default;
var SearchWebSvg = require("../../shared/img/illustrations/search-web.svg").default;
var StarAwardSvg = require("../../shared/img/illustrations/star-award.svg").default;
var CircleArrowBottomSvg = require("../../shared/img/icons/circle-arrow-bottom.svg").default;
var CircleChevronLeftSvg = require("../../shared/img/icons/circle-chevron-left.svg").default;
var HandshakeXSvg = require("../../shared/img/illustrations/handshake-x.svg").default;
var OrientationSvg = require("../../shared/img/illustrations/orientation.svg").default;
var PhoneTouchSvg = require("../../shared/img/illustrations/phone-touch.svg").default;
var RobotRoundSvg = require("../../shared/img/illustrations/robot-round.svg").default;
var CircleChevronRightSvg = require("../../shared/img/icons/circle-chevron-right.svg").default;
var ChartGrowthSvg = require("../../shared/img/illustrations/chart-growth.svg").default;
var DesktopLinkSvg = require("../../shared/img/illustrations/desktop-link.svg").default;
var MapUsaFullSvg = require("../../shared/img/illustrations/map-usa-full.svg").default;
var MoneyHandXSvg = require("../../shared/img/illustrations/money-hand-x.svg").default;
var RobotSquareSvg = require("../../shared/img/illustrations/robot-square.svg").default;
var CircleCheckedFilledSvg = require("../../shared/img/icons/circle-checked-filled.svg").default;
var CircleChevronBottomSvg = require("../../shared/img/icons/circle-chevron-bottom.svg").default;
var AmericanFlagSvg$1 = require("../../shared/img/illustrations/american-flag.svg").default;
var AttireCustomSvg = require("../../shared/img/illustrations/attire-custom.svg").default;
var BackOfHouseSvg = require("../../shared/img/illustrations/back-of-house.svg").default;
var DistanceRoadSvg = require("../../shared/img/illustrations/distance-road.svg").default;
var FoodHandlersSvg = require("../../shared/img/illustrations/food-handlers.svg").default;
var FreeToBeUsSvg = require("../../shared/img/illustrations/free-to-be-us.svg").default;
var MapUsaBlankSvg = require("../../shared/img/illustrations/map-usa-blank.svg").default;
var PhoneMessageSvg = require("../../shared/img/illustrations/phone-message.svg").default;
var PhoneProfileSvg = require("../../shared/img/illustrations/phone-profile.svg").default;
var ProfessionalsSvg = require("../../shared/img/illustrations/professionals.svg").default;
var SearchPersonSvg = require("../../shared/img/illustrations/search-person.svg").default;
var ThumbsRatingSvg = require("../../shared/img/illustrations/thumbs-rating.svg").default;
var CircleMoreHorizontalSvg = require("../../shared/img/icons/circle-more-horizontal.svg").default;
var StarPentagonSvg = require("../../shared/img/illustrations/5star-pentagon.svg").default;
var ClockUtensilsSvg = require("../../shared/img/illustrations/clock-utensils.svg").default;
var RevenueGrowthSvg = require("../../shared/img/illustrations/revenue-growth.svg").default;
var WorldLocationSvg = require("../../shared/img/illustrations/world-location.svg").default;
var BusinessDarkVerticalSvg = require("../../shared/img/logos/business-dark-vertical.svg").default;
var RefreshClockwiseAlertSvg = require("../../shared/img/icons/refresh-clockwise-alert.svg").default;
var AttentionWhiteSvg = require("../../shared/img/illustrations/attention-white.svg").default;
var CircleQuestionSvg$1 = require("../../shared/img/illustrations/circle-question.svg").default;
var DesktopWebsiteSvg = require("../../shared/img/illustrations/desktop-website.svg").default;
var HandshakeXRedSvg = require("../../shared/img/illustrations/handshake-x-red.svg").default;
var HeartHandshakeSvg = require("../../shared/img/illustrations/heart-handshake.svg").default;
var BusinessLightVerticalSvg = require("../../shared/img/logos/business-light-vertical.svg").default;
var CircleArrowLeftCurvedSvg = require("../../shared/img/icons/circle-arrow-left-curved.svg").default;
var RotateCounterClockwiseSvg = require("../../shared/img/icons/rotate-counter-clockwise.svg").default;
var GpsLocationPinSvg = require("../../shared/img/illustrations/gps-location-pin.svg").default;
var CircleArrowRightCurvedSvg = require("../../shared/img/icons/circle-arrow-right-curved.svg").default;
var RefreshCounterClockwiseSvg = require("../../shared/img/icons/refresh-counter-clockwise.svg").default;
var ClockUtensilSetSvg = require("../../shared/img/illustrations/clock-utensil-set.svg").default;
var NotificationBellSvg = require("../../shared/img/illustrations/notification-bell.svg").default;
var CircleExclamationSvg = require("../../shared/img/illustrations/circle-exclamation.svg").default;
var CircleInformationSvg = require("../../shared/img/illustrations/circle-information.svg").default;
var ConstantlyCuriousSvg = require("../../shared/img/illustrations/constantly-curious.svg").default;
var MoneyFlowDiagramSvg = require("../../shared/img/illustrations/money-flow-diagram.svg").default;
var PhoneNotificationSvg = require("../../shared/img/illustrations/phone-notification.svg").default;
var StopwatchUtensilsSvg = require("../../shared/img/illustrations/stopwatch-utensils.svg").default;
var PeopleGroupAttendSvg = require("../../shared/img/illustrations/people-group-attend.svg").default;
var GpsLocationPinRedSvg = require("../../shared/img/illustrations/gps-location-pin-red.svg").default;
var AlcoholCertificationSvg = require("../../shared/img/illustrations/alcohol-certification.svg").default;
var AttireBlackOnBlackSvg = require("../../shared/img/illustrations/attire-black-on-black.svg").default;
var AttireWhiteOnBlackSvg = require("../../shared/img/illustrations/attire-white-on-black.svg").default;
var CalendarCircleCheckSvg = require("../../shared/img/illustrations/calendar-circle-check.svg").default;
var CalendarTargetCheckSvg = require("../../shared/img/illustrations/calendar-target-check.svg").default;
var ShakerBottleMartiniSvg = require("../../shared/img/illustrations/shaker-bottle-martini.svg").default;
var StopwatchUrgentFastSvg = require("../../shared/img/illustrations/stopwatch-urgent-fast.svg").default;
var FoodBeverageBuildingSvg = require("../../shared/img/illustrations/food-beverage-building.svg").default;
var PaperShieldCheckmarkSvg = require("../../shared/img/illustrations/paper-shield-checkmark.svg").default;
var RefreshCounterClockwiseAlertSvg = require("../../shared/img/icons/refresh-counter-clockwise-alert.svg").default;
var CalendarTargetQuestionSvg = require("../../shared/img/illustrations/calendar-target-question.svg").default;
var TwoHandsShieldCheckmarkSvg = require("../../shared/img/illustrations/two-hands-shield-checkmark.svg").default;
var CalendarTargetExclamationSvg = require("../../shared/img/illustrations/calendar-target-exclamation.svg").default;
var FindProfessionalsHandsCardsSvg = require("../../shared/img/illustrations/find-professionals-hands-cards.svg").default;
var CalendarTargetExclamationRedSvg = require("../../shared/img/illustrations/calendar-target-exclamation-red.svg").default;

var toFloat = CommonStyleTypes.Point.toFloat;

var multiplyWithFloat = CommonStyleTypes.Point.multiplyWithFloat;

var remPerPoint = 1.0 / 16.0;

function convertToUnit(ratio) {
  return function (param) {
    return Relude_Globals.$great$great(toFloat, (function (param) {
                  return ratio * param;
                }), param);
  };
}

var toRemValue = convertToUnit(remPerPoint);

function toRem(param) {
  return Relude_Globals.$great$great(toRemValue, Css.rem, param);
}

var partial_arg = convertToUnit(1.0);

function partial_arg$1(param) {
  return Relude_Globals.$great$great(partial_arg, Relude_Float.roundAsInt, param);
}

function toPx(param) {
  return Relude_Globals.$great$great(partial_arg$1, Css.px, param);
}

function toRawPxValue(param) {
  return Relude_Globals.$great$great(toPx, (function (param) {
                return param.VAL;
              }), param);
}

function extendBaseStyle(baseStyle, extendedStyle) {
  return Curry._1(Css.merge, Relude_List.mapOption(Relude_Globals.id, {
                  hd: baseStyle,
                  tl: {
                    hd: extendedStyle,
                    tl: /* [] */0
                  }
                }));
}

var defaultAvatarColors = [
  Css.hex("1bbc9c"),
  Css.hex("2fcc71"),
  Css.hex("3398db"),
  Css.hex("9b59b6"),
  Css.hex("34485e"),
  Css.hex("f1c310"),
  Css.hex("e67e21"),
  Css.hex("e74c3c")
];

var partial_arg$2 = Curry._2(Relude_Array.foldLeft, (function (prim, prim$1) {
        return prim + prim$1 | 0;
      }), 0);

function partial_arg$3(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_String.splitArray("", param);
                            }), (function (param) {
                              return Relude_Array.mapOption((function (param) {
                                            return param.codePointAt(0);
                                          }), param);
                            }), param);
              }), partial_arg$2, param);
}

function getColorForString(param) {
  return Relude_Globals.$great$great(partial_arg$3, (function (stringHash) {
                return Relude_Option.getOrThrow(Relude_Array.at(Caml_int32.mod_(stringHash, Relude_Array.length(defaultAvatarColors)), defaultAvatarColors));
              }), param);
}

var Utils = {
  extendBaseStyle: extendBaseStyle,
  defaultAvatarColors: defaultAvatarColors,
  getColorForString: getColorForString
};

function toString(param) {
  if (param) {
    return "Open Sans";
  } else {
    return "Quicksand";
  }
}

var Font = {
  toString: toString
};

var inheritTypographyStyles = Curry._1(Css.style, {
      hd: Css.fontFamily("inherit_"),
      tl: {
        hd: Css.fontSize(Css.inherit_),
        tl: {
          hd: Css.fontWeight(Css.inherit_),
          tl: {
            hd: Css.lineHeight(Css.inherit_),
            tl: /* [] */0
          }
        }
      }
    });

var Typography = {
  Font: Font,
  Weight: undefined,
  Size: undefined,
  inheritTypographyStyles: inheritTypographyStyles
};

function rawValueToColor(hex) {
  if (typeof hex === "number") {
    if (hex !== 0) {
      return Css.transparent;
    } else {
      return Css.currentColor;
    }
  } else {
    return Css.hex(hex._0);
  }
}

var include = CommonStyleTypes.ColorConverter({
      rawValueToColor: rawValueToColor
    });

var toRawValue = include.toRawValue;

var toColor = include.toColor;

function toString$1(param) {
  return Relude_Globals.$great$great(toRawValue, (function (hex) {
                if (typeof hex === "number") {
                  if (hex !== 0) {
                    return "rgba(0, 0, 0, 0)";
                  } else {
                    return "currentColor";
                  }
                } else {
                  return "#" + hex._0;
                }
              }), param);
}

var partial_arg$4 = /[a-f0-9]{6}/i;

var partial_arg$5 = Relude_Option.filter(function (param) {
      return partial_arg$4.test(param);
    });

function toValidHexColor(param) {
  return Relude_Globals.$great$great(Relude_Option.pure, partial_arg$5, param);
}

function tToRgba(opacity) {
  return function (param) {
    return Relude_Globals.$great$great(toRawValue, (function (hex) {
                  if (typeof hex === "number") {
                    if (hex !== 0) {
                      return Css.transparent;
                    } else {
                      return Css.currentColor;
                    }
                  } else {
                    return Relude_Option.getOrThrow(Curry._2(Relude_Option.flatMap, (function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_String.splitList("", param);
                                                  }), (function (param) {
                                                    if (!param) {
                                                      return ;
                                                    }
                                                    var match = param.tl;
                                                    if (!match) {
                                                      return ;
                                                    }
                                                    var match$1 = match.tl;
                                                    if (!match$1) {
                                                      return ;
                                                    }
                                                    var match$2 = match$1.tl;
                                                    if (!match$2) {
                                                      return ;
                                                    }
                                                    var match$3 = match$2.tl;
                                                    if (!match$3) {
                                                      return ;
                                                    }
                                                    var match$4 = match$3.tl;
                                                    if (match$4 && !match$4.tl) {
                                                      return Curry._2(Relude_Option.mapTuple3, (function (r, g, b) {
                                                                    return Css.rgba(r, g, b, opacity);
                                                                  }), [
                                                                  MathUtils.hexStringToInt(param.hd + match.hd),
                                                                  MathUtils.hexStringToInt(match$1.hd + match$2.hd),
                                                                  MathUtils.hexStringToInt(match$3.hd + match$4.hd)
                                                                ]);
                                                    }
                                                    
                                                  }), param);
                                    }), Curry._1(toValidHexColor, hex._0)));
                  }
                }), param);
  };
}

var include$1 = CommonStyleTypes.SpacingConverter({
      pointToSpacing: toRem
    });

var Spacing_toPoint = CommonStyleTypes.Spacing.toPoint;

var Spacing_toSpacing = include$1.toSpacing;

var Spacing_xxSmall = include$1.xxSmall;

var Spacing_xSmall = include$1.xSmall;

var Spacing_small = include$1.small;

var Spacing_medium = include$1.medium;

var Spacing_large = include$1.large;

var Spacing_xLarge = include$1.xLarge;

var Spacing_xxLarge = include$1.xxLarge;

var Spacing_xxxLarge = include$1.xxxLarge;

var Spacing_xxxxLarge = include$1.xxxxLarge;

var Spacing = {
  toPoint: Spacing_toPoint,
  toSpacing: Spacing_toSpacing,
  xxSmall: Spacing_xxSmall,
  xSmall: Spacing_xSmall,
  small: Spacing_small,
  medium: Spacing_medium,
  large: Spacing_large,
  xLarge: Spacing_xLarge,
  xxLarge: Spacing_xxLarge,
  xxxLarge: Spacing_xxxLarge,
  xxxxLarge: Spacing_xxxxLarge
};

function sizeToRem(param) {
  return Relude_Globals.$great$great(CommonStyleTypes.Icon.Size.toPoint, toRem, param);
}

var make = AddUserSvg;

var make$1 = AlarmCheckedSvg;

var make$2 = AlarmLateSvg;

var make$3 = AlarmPlusSvg;

var make$4 = AlertCircleSvg;

var make$5 = AlertTriangleSvg;

var make$6 = AmericanFlagSvg;

var make$7 = ArrowBoldBottomSvg;

var make$8 = ArrowBoldLeftSvg;

var make$9 = ArrowBoldRedoSvg;

var make$10 = ArrowBoldRightSvg;

var make$11 = ArrowBoldTopSvg;

var make$12 = ArrowBoldUndoSvg;

var make$13 = ArrowBottomSvg;

var make$14 = ArrowLeftSvg;

var make$15 = ArrowRightSvg;

var make$16 = ArrowTopSvg;

var make$17 = AtSignSvg;

var make$18 = BartenderSvg;

var make$19 = BehanceSvg;

var make$20 = BellSvg;

var make$21 = BigplusSvg;

var make$22 = BoltSvg;

var make$23 = BookSvg;

var make$24 = BriefcaseSvg;

var make$25 = BrightnessHighSvg;

var make$26 = CalendarSvg;

var make$27 = CalendarCheckedSvg;

var make$28 = CalendarDatesSvg;

var make$29 = CalendarPlusSvg;

var make$30 = CameraSvg;

var make$31 = CameraCreateSvg;

var make$32 = CameraNoSvg;

var make$33 = CannedResponsesSvg;

var make$34 = CarSvg;

var make$35 = CarBlockSvg;

var make$36 = CarCheckSvg;

var make$37 = CheckMarkSvg;

var make$38 = ChevronBottomSvg;

var make$39 = ChevronLeftSvg;

var make$40 = ChevronRightSvg;

var make$41 = ChevronsUpDownSvg;

var make$42 = ChevronTopSvg;

var make$43 = CircleArrowBottomSvg;

var make$44 = CircleArrowLeftCurvedSvg;

var make$45 = CircleArrowLeftSvg;

var make$46 = CircleArrowRightCurvedSvg;

var make$47 = CircleArrowRightSvg;

var make$48 = CircleArrowTopSvg;

var make$49 = CircleBlockSvg;

var make$50 = CircleCheckedSvg;

var make$51 = CircleCheckedFilledSvg;

var make$52 = CircleChevronBottomSvg;

var make$53 = CircleChevronLeftSvg;

var make$54 = CircleChevronRightSvg;

var make$55 = CircleChevronTopSvg;

var make$56 = CircleMinusSvg;

var make$57 = CircleMoreHorizontalSvg;

var make$58 = CirclePlusSvg;

var make$59 = CircleQuestionSvg;

var make$60 = CircleStarSvg;

var make$61 = CircleXSvg;

var make$62 = ClipboardSvg;

var make$63 = ClockSvg;

var make$64 = CommentSvg;

var make$65 = CommentCheckedSvg;

var make$66 = CommentDeleteSvg;

var make$67 = CommentMinusSvg;

var make$68 = CommentPlusSvg;

var make$69 = CommentTextSvg;

var make$70 = ConfirmSvg;

var make$71 = CookSvg;

var make$72 = CopySvg;

var make$73 = CreditcardSvg;

var make$74 = CrossStreetSvg;

var make$75 = DaySvg;

var make$76 = DeleteSvg;

var make$77 = DirectionSvg;

var make$78 = DocumentSvg;

var make$79 = DollarSvg;

var make$80 = DownloadSvg;

var make$81 = DribbbleSvg;

var make$82 = EveningSvg;

var make$83 = EyeSvg;

var make$84 = EyeNoSvg;

var make$85 = FacebookSvg;

var make$86 = FlagFilledSvg;

var make$87 = FormSvg;

var make$88 = GenLaborSvg;

var make$89 = GoogleSvg;

var make$90 = HashtagSvg;

var make$91 = HeartSvg;

var make$92 = HomeSvg;

var make$93 = ImageSvg;

var make$94 = InboxSvg;

var make$95 = InfoSvg;

var make$96 = InstagramSvg;

var make$97 = LinkSvg;

var make$98 = LinkedinSvg;

var make$99 = ListSvg;

var make$100 = LocationSvg;

var make$101 = LockCircleSvg;

var make$102 = MailSvg;

var make$103 = MatchesSvg;

var make$104 = MenuSvg;

var make$105 = MicrophoneSvg;

var make$106 = MicrophoneMutedSvg;

var make$107 = MinusSvg;

var make$108 = MoonSvg;

var make$109 = MoreHorSvg;

var make$110 = MoreVertSvg;

var make$111 = MorningSvg;

var make$112 = NewspaperSvg;

var make$113 = PasswordSvg;

var make$114 = QrCodeSvg;

var make$115 = PencilCreateSvg;

var make$116 = PencilEditSvg;

var make$117 = PhoneSvg;

var make$118 = PinNoSvg;

var make$119 = PlusSvg;

var make$120 = ProfileSvg;

var make$121 = QuestionSvg;

var make$122 = QuestionCircleSvg;

var make$123 = RefreshClockwiseSvg;

var make$124 = RefreshClockwiseAlertSvg;

var make$125 = RefreshCounterClockwiseSvg;

var make$126 = RefreshCounterClockwiseAlertSvg;

var make$127 = RotateClockwiseSvg;

var make$128 = RotateCounterClockwiseSvg;

var make$129 = SearchSvg;

var make$130 = SelectAreaSvg;

var make$131 = SendSvg;

var make$132 = ServerSvg;

var make$133 = SettingsSvg;

var make$134 = ShareSvg;

var make$135 = ShirtSvg;

var make$136 = StarSvg;

var make$137 = StarFilledSvg;

var make$138 = StarNoSvg;

var make$139 = ThumbsUpSvg;

var make$140 = TimeSvg;

var make$141 = TimeBackSvg;

var make$142 = TrashSvg;

var make$143 = TwitterSvg;

var make$144 = UploadSvg;

var make$145 = UsersSvg;

var make$146 = UniformBulletSvg;

var make$147 = VerifiedSvg;

var make$148 = VideoCameraSvg;

var make$149 = VideoCameraPlusSvg;

var make$150 = XSvg;

var make$151 = YoutubeSvg;

function getShiftTypeCategoryIconSource(param) {
  var match = Curry._1(CommonTypes_ShiftType_Category.Id.toInt, param.id);
  switch (match) {
    case 1 :
        return React.createElement(make$132, {});
    case 2 :
        return React.createElement(make$18, {});
    case 3 :
        return React.createElement(make$71, {});
    default:
      return React.createElement(make$88, {});
  }
}

function toElement(param) {
  if (param.TAG === /* Large */0) {
    var shiftTypeCategory = param._0;
    if (typeof shiftTypeCategory === "number") {
      if (shiftTypeCategory === /* Clock */0) {
        return React.createElement(make$63, {});
      } else {
        return React.createElement(make$70, {});
      }
    }
    switch (shiftTypeCategory.TAG | 0) {
      case /* Availability */0 :
          switch (shiftTypeCategory._0) {
            case /* Day */0 :
                return React.createElement(make$75, {});
            case /* Evening */1 :
                return React.createElement(make$82, {});
            case /* Morning */2 :
                return React.createElement(make$111, {});
            
          }
      case /* ShiftType */1 :
          return getShiftTypeCategoryIconSource(shiftTypeCategory._0.category);
      case /* ShiftTypeCategory */2 :
          return getShiftTypeCategoryIconSource(shiftTypeCategory._0);
      
    }
  } else {
    var match = param._0;
    switch (match.TAG | 0) {
      case /* Arrow */0 :
          switch (match._0) {
            case /* ArrowBoldBottom */0 :
                return React.createElement(make$7, {});
            case /* ArrowBoldLeft */1 :
                return React.createElement(make$8, {});
            case /* ArrowBoldRedo */2 :
                return React.createElement(make$9, {});
            case /* ArrowBoldRight */3 :
                return React.createElement(make$10, {});
            case /* ArrowBoldTop */4 :
                return React.createElement(make$11, {});
            case /* ArrowBoldUndo */5 :
                return React.createElement(make$12, {});
            case /* ArrowBottom */6 :
                return React.createElement(make$13, {});
            case /* ArrowLeft */7 :
                return React.createElement(make$14, {});
            case /* ArrowRight */8 :
                return React.createElement(make$15, {});
            case /* ArrowTop */9 :
                return React.createElement(make$16, {});
            case /* ChevronBottom */10 :
                return React.createElement(make$38, {});
            case /* ChevronLeft */11 :
                return React.createElement(make$39, {});
            case /* ChevronRight */12 :
                return React.createElement(make$40, {});
            case /* ChevronsUpDown */13 :
                return React.createElement(make$41, {});
            case /* ChevronTop */14 :
                return React.createElement(make$42, {});
            case /* CircleArrowBottom */15 :
                return React.createElement(make$43, {});
            case /* CircleArrowLeft */16 :
                return React.createElement(make$45, {});
            case /* CircleArrowLeftCurved */17 :
                return React.createElement(make$44, {});
            case /* CircleArrowRight */18 :
                return React.createElement(make$47, {});
            case /* CircleArrowRightCurved */19 :
                return React.createElement(make$46, {});
            case /* CircleArrowTop */20 :
                return React.createElement(make$48, {});
            case /* CircleChevronBottom */21 :
                return React.createElement(make$52, {});
            case /* CircleChevronLeft */22 :
                return React.createElement(make$53, {});
            case /* CircleChevronRight */23 :
                return React.createElement(make$54, {});
            case /* CircleChevronTop */24 :
                return React.createElement(make$55, {});
            
          }
      case /* Button */1 :
          switch (match._0) {
            case /* AlarmChecked */0 :
                return React.createElement(make$1, {});
            case /* AlarmLate */1 :
                return React.createElement(make$2, {});
            case /* AlarmPlus */2 :
                return React.createElement(make$3, {});
            case /* Camera */3 :
                return React.createElement(make$30, {});
            case /* Checkmark */4 :
                return React.createElement(make$37, {});
            case /* Download */5 :
                return React.createElement(make$80, {});
            case /* Image */6 :
                return React.createElement(make$93, {});
            case /* Link */7 :
                return React.createElement(make$97, {});
            case /* Microphone */8 :
                return React.createElement(make$105, {});
            case /* MicrophoneMuted */9 :
                return React.createElement(make$106, {});
            case /* ThumbsUp */10 :
                return React.createElement(make$139, {});
            case /* Time */11 :
                return React.createElement(make$140, {});
            case /* TimeBack */12 :
                return React.createElement(make$141, {});
            case /* Upload */13 :
                return React.createElement(make$144, {});
            case /* X */14 :
                return React.createElement(make$150, {});
            
          }
      case /* InputField */2 :
          switch (match._0) {
            case /* BigPlus */0 :
                return React.createElement(make$21, {});
            case /* Dollar */1 :
                return React.createElement(make$79, {});
            case /* Eye */2 :
                return React.createElement(make$83, {});
            case /* EyeNo */3 :
                return React.createElement(make$84, {});
            case /* AmericanFlag */4 :
                return React.createElement(make$6, {});
            case /* Hashtag */5 :
                return React.createElement(make$90, {});
            case /* LockCircle */6 :
                return React.createElement(make$101, {});
            case /* Mail */7 :
                return React.createElement(make$102, {});
            case /* PencilCreate */8 :
                return React.createElement(make$115, {});
            
          }
      case /* Messaging */3 :
          switch (match._0) {
            case /* CannedResponses */0 :
                return React.createElement(make$33, {});
            case /* Comment */1 :
                return React.createElement(make$64, {});
            case /* CommentChecked */2 :
                return React.createElement(make$65, {});
            case /* CommentDelete */3 :
                return React.createElement(make$66, {});
            case /* CommentMinus */4 :
                return React.createElement(make$67, {});
            case /* CommentPlus */5 :
                return React.createElement(make$68, {});
            case /* CommentText */6 :
                return React.createElement(make$69, {});
            case /* Delete */7 :
                return React.createElement(make$76, {});
            case /* Question */8 :
                return React.createElement(make$121, {});
            case /* Send */9 :
                return React.createElement(make$131, {});
            
          }
      case /* Misc */4 :
          switch (match._0) {
            case /* Bolt */0 :
                return React.createElement(make$22, {});
            case /* Book */1 :
                return React.createElement(make$23, {});
            case /* Briefcase */2 :
                return React.createElement(make$24, {});
            case /* BrightnessHigh */3 :
                return React.createElement(make$25, {});
            case /* CameraCreate */4 :
                return React.createElement(make$31, {});
            case /* CameraNo */5 :
                return React.createElement(make$32, {});
            case /* CreditCard */6 :
                return React.createElement(make$73, {});
            case /* FlagFilled */7 :
                return React.createElement(make$86, {});
            case /* Form */8 :
                return React.createElement(make$87, {});
            case /* Heart */9 :
                return React.createElement(make$91, {});
            case /* List */10 :
                return React.createElement(make$99, {});
            case /* Moon */11 :
                return React.createElement(make$108, {});
            case /* Newspaper */12 :
                return React.createElement(make$112, {});
            case /* Password */13 :
                return React.createElement(make$113, {});
            case /* PinNo */14 :
                return React.createElement(make$118, {});
            case /* Share */15 :
                return React.createElement(make$134, {});
            case /* Trash */16 :
                return React.createElement(make$142, {});
            
          }
      case /* Navigation */5 :
          switch (match._0) {
            case /* Home */0 :
                return React.createElement(make$92, {});
            case /* Inbox */1 :
                return React.createElement(make$94, {});
            case /* Matches */2 :
                return React.createElement(make$103, {});
            case /* Menu */3 :
                return React.createElement(make$104, {});
            case /* Minus */4 :
                return React.createElement(make$107, {});
            case /* MoreHorizontal */5 :
                return React.createElement(make$109, {});
            case /* MoreVertical */6 :
                return React.createElement(make$110, {});
            case /* Plus */7 :
                return React.createElement(make$119, {});
            case /* Profile */8 :
                return React.createElement(make$120, {});
            case /* RefreshCounterClockwise */9 :
                return React.createElement(make$125, {});
            case /* RefreshCounterClockwiseAlert */10 :
                return React.createElement(make$126, {});
            case /* RefreshClockwise */11 :
                return React.createElement(make$123, {});
            case /* RefreshClockwiseAlert */12 :
                return React.createElement(make$124, {});
            case /* RotateCounterClockwise */13 :
                return React.createElement(make$128, {});
            case /* RotateClockwise */14 :
                return React.createElement(make$127, {});
            case /* Search */15 :
                return React.createElement(make$129, {});
            case /* Settings */16 :
                return React.createElement(make$133, {});
            
          }
      case /* Shift */6 :
          switch (match._0) {
            case /* AddUser */0 :
                return React.createElement(make, {});
            case /* Calendar */1 :
                return React.createElement(make$26, {});
            case /* CalendarChecked */2 :
                return React.createElement(make$27, {});
            case /* CalendarDates */3 :
                return React.createElement(make$28, {});
            case /* CalendarPlus */4 :
                return React.createElement(make$29, {});
            case /* Car */5 :
                return React.createElement(make$34, {});
            case /* CarBlock */6 :
                return React.createElement(make$35, {});
            case /* CarChecked */7 :
                return React.createElement(make$36, {});
            case /* Clipboard */8 :
                return React.createElement(make$62, {});
            case /* Copy */9 :
                return React.createElement(make$72, {});
            case /* CrossStreet */10 :
                return React.createElement(make$74, {});
            case /* Direction */11 :
                return React.createElement(make$77, {});
            case /* Document */12 :
                return React.createElement(make$78, {});
            case /* Location */13 :
                return React.createElement(make$100, {});
            case /* Matches */14 :
                return React.createElement(make$103, {});
            case /* QRCode */15 :
                return React.createElement(make$114, {});
            case /* PencilEdit */16 :
                return React.createElement(make$116, {});
            case /* Phone */17 :
                return React.createElement(make$117, {});
            case /* SelectArea */18 :
                return React.createElement(make$130, {});
            case /* Shirt */19 :
                return React.createElement(make$135, {});
            case /* Star */20 :
                return React.createElement(make$136, {});
            case /* StarFilled */21 :
                return React.createElement(make$137, {});
            case /* StarNo */22 :
                return React.createElement(make$138, {});
            case /* Users */23 :
                return React.createElement(make$145, {});
            case /* UniformBullet */24 :
                return React.createElement(make$146, {});
            case /* VideoCamera */25 :
                return React.createElement(make$148, {});
            case /* VideoCameraPlus */26 :
                return React.createElement(make$149, {});
            
          }
      case /* Social */7 :
          switch (match._0) {
            case /* AtSign */0 :
                return React.createElement(make$17, {});
            case /* Behance */1 :
                return React.createElement(make$19, {});
            case /* Dribbble */2 :
                return React.createElement(make$81, {});
            case /* Facebook */3 :
                return React.createElement(make$85, {});
            case /* Google */4 :
                return React.createElement(make$89, {});
            case /* Instagram */5 :
                return React.createElement(make$96, {});
            case /* LinkedIn */6 :
                return React.createElement(make$98, {});
            case /* Twitter */7 :
                return React.createElement(make$143, {});
            case /* YouTube */8 :
                return React.createElement(make$151, {});
            
          }
      case /* Status */8 :
          switch (match._0) {
            case /* AlertCircle */0 :
                return React.createElement(make$4, {});
            case /* AlertTriangle */1 :
                return React.createElement(make$5, {});
            case /* Bell */2 :
                return React.createElement(make$20, {});
            case /* CircleBlock */3 :
                return React.createElement(make$49, {});
            case /* CircleChecked */4 :
                return React.createElement(make$50, {});
            case /* CircleCheckedFilled */5 :
                return React.createElement(make$51, {});
            case /* CircleMinus */6 :
                return React.createElement(make$56, {});
            case /* CircleMoreHorizontal */7 :
                return React.createElement(make$57, {});
            case /* CirclePlus */8 :
                return React.createElement(make$58, {});
            case /* CircleQuestion */9 :
                return React.createElement(make$59, {});
            case /* CircleStar */10 :
                return React.createElement(make$60, {});
            case /* CircleX */11 :
                return React.createElement(make$61, {});
            case /* Info */12 :
                return React.createElement(make$95, {});
            case /* QuestionCircle */13 :
                return React.createElement(make$122, {});
            case /* Verified */14 :
                return React.createElement(make$147, {});
            
          }
      
    }
  }
}

var make$152 = BlobSvg;

var make$153 = BlobNegativeSvg;

var make$154 = BlobSvg$1;

var make$155 = BlobNegativeSvg$1;

var make$156 = BlobSvg$2;

var make$157 = BlobNegativeSvg$2;

var make$158 = BlobSvg$3;

var make$159 = BlobNegativeSvg$3;

var make$160 = BlobSvg$4;

var make$161 = BlobNegativeSvg$4;

var make$162 = BusinessDarkSvg;

var make$163 = BusinessDarkVerticalSvg;

var make$164 = BusinessLightSvg;

var make$165 = BusinessLightVerticalSvg;

var make$166 = DarkSvg;

var make$167 = QwickISvg;

var make$168 = LightSvg;

var make$169 = AlcoholCertificationSvg;

var make$170 = AmericanFlagSvg$1;

var make$171 = AttentionSvg;

var make$172 = AttentionWhiteSvg;

var make$173 = AttireSvg;

var make$174 = BackOfHouseSvg;

var make$175 = BartenderSvg$1;

var make$176 = CalendarCircleCheckSvg;

var make$177 = CalendarTargetCheckSvg;

var make$178 = CalendarTargetExclamationSvg;

var make$179 = CalendarTargetExclamationRedSvg;

var make$180 = CalendarTargetQuestionSvg;

var make$181 = CaAbSvg;

var make$182 = CameraSvg$1;

var make$183 = ChartGrowthSvg;

var make$184 = ChecklistSvg;

var make$185 = CircleExclamationSvg;

var make$186 = CircleInformationSvg;

var make$187 = CircleQuestionSvg$1;

var make$188 = ClockUtensilsSvg;

var make$189 = ClockUtensilSetSvg;

var make$190 = CommunitySvg;

var make$191 = CongratsSvg;

var make$192 = ConstantlyCuriousSvg;

var make$193 = CreditcardSvg$1;

var make$194 = CutRibbonSvg;

var make$195 = DesktopSvg;

var make$196 = DesktopLinkSvg;

var make$197 = DesktopWebsiteSvg;

var make$198 = DistanceRoadSvg;

var make$199 = AttireBlackOnBlackSvg;

var make$200 = AttireCustomSvg;

var make$201 = AttireWhiteOnBlackSvg;

var make$202 = FindProfessionalsHandsCardsSvg;

var make$203 = FireworkSvg;

var make$204 = StarPentagonSvg;

var make$205 = FoodBeverageBuildingSvg;

var make$206 = FoodHandlersSvg;

var make$207 = FreeToBeUsSvg;

var make$208 = GpsLocationPinSvg;

var make$209 = GpsLocationPinRedSvg;

var make$210 = GrowthSvg;

var make$211 = HandshakeSvg;

var make$212 = HandshakeXSvg;

var make$213 = HandshakeXRedSvg;

var make$214 = HeadGearsSvg;

var make$215 = HeartHandshakeSvg;

var make$216 = HourglassSvg;

var make$217 = IdBadgeSvg;

var make$218 = InterviewSvg;

var make$219 = KeyboardSvg;

var make$220 = LaptopSvg;

var make$221 = LawSvg;

var make$222 = MakeMovesSvg;

var make$223 = MapPinSvg;

var make$224 = MapUsaBlankSvg;

var make$225 = MapUsaFullSvg;

var make$226 = ArizonaSvg;

var make$227 = AtlantaSvg;

var make$228 = ChicagoSvg;

var make$229 = DallasSvg;

var make$230 = HoustonSvg;

var make$231 = MiamiSvg;

var make$232 = NewjerseySvg;

var make$233 = NewyorkSvg;

var make$234 = SandiegoSvg;

var make$235 = TexasAllSvg;

var make$236 = MaskSvg;

var make$237 = MaskRedSvg;

var make$238 = MeetingXSvg;

var make$239 = MessagesSvg;

var make$240 = MoneyBagSvg;

var make$241 = MoneyFlowDiagramSvg;

var make$242 = MoneyHandXSvg;

var make$243 = NewBadgeSvg;

var make$244 = NotificationBellSvg;

var make$245 = OrientationSvg;

var make$246 = PaperShieldCheckmarkSvg;

var make$247 = PeopleGroupAttendSvg;

var make$248 = PersonXSvg;

var make$249 = PhoneMessageSvg;

var make$250 = PhoneNotificationSvg;

var make$251 = PhoneProfileSvg;

var make$252 = PhoneTouchSvg;

var make$253 = PinNumberSvg;

var make$254 = PresentSvg;

var make$255 = ProfessionalsSvg;

var make$256 = RecruitingSvg;

var make$257 = RevenueGrowthSvg;

var make$258 = RobotRoundSvg;

var make$259 = RobotSquareSvg;

var make$260 = SearchPersonSvg;

var make$261 = SearchWebSvg;

var make$262 = ServerSvg$1;

var make$263 = ShakerBottleMartiniSvg;

var make$264 = FacebookSvg$1;

var make$265 = InstagramSvg$1;

var make$266 = LinkedinSvg$1;

var make$267 = TwitterSvg$1;

var make$268 = StarAwardSvg;

var make$269 = StopwatchUrgentFastSvg;

var make$270 = StopwatchUtensilsSvg;

var make$271 = ThumbsRatingSvg;

var make$272 = ThumbsUpSvg$1;

var make$273 = TwoHandsShieldCheckmarkSvg;

var make$274 = WorldLocationSvg;

var heroBusiness = require("../img/hero-business.jpg");

var heroProfessional = require("../img/hero-professional.jpg");

var pencilIcon = require("../img/pencil.png");

var qwickDarkBg = require("../img/qwickDarkBg.png");

var qwickIcon = require("../img/qwickIcon.png");

var qwickIconSq = require("../img/qwickIconSq.png");

var qwickWhiteBg = require("../img/qwickWhiteBg.png");

var robotIcon = require("../img/robot.png");

var zapIcon = require("../img/zapier.png");

function toElement$1(param) {
  switch (param.TAG | 0) {
    case /* Blob */0 :
        switch (param._0) {
          case /* One */0 :
              return React.createElement(make$152, {});
          case /* OneNegative */1 :
              return React.createElement(make$153, {});
          case /* Two */2 :
              return React.createElement(make$154, {});
          case /* TwoNegative */3 :
              return React.createElement(make$155, {});
          case /* Three */4 :
              return React.createElement(make$156, {});
          case /* ThreeNegative */5 :
              return React.createElement(make$157, {});
          case /* Four */6 :
              return React.createElement(make$158, {});
          case /* FourNegative */7 :
              return React.createElement(make$159, {});
          case /* Five */8 :
              return React.createElement(make$160, {});
          case /* FiveNegative */9 :
              return React.createElement(make$161, {});
          
        }
    case /* Illustration */1 :
        var match = param._0;
        if (typeof match === "number") {
          switch (match) {
            case /* AlcoholCertification */0 :
                return React.createElement(make$169, {});
            case /* AmericanFlag */1 :
                return React.createElement(make$170, {});
            case /* Attention */2 :
                return React.createElement(make$171, {});
            case /* AttentionWhite */3 :
                return React.createElement(make$172, {});
            case /* Attire */4 :
                return React.createElement(make$173, {});
            case /* BackOfHouse */5 :
                return React.createElement(make$174, {});
            case /* Bartender */6 :
                return React.createElement(make$175, {});
            case /* CalendarCircleCheck */7 :
                return React.createElement(make$176, {});
            case /* CalendarTargetCheck */8 :
                return React.createElement(make$177, {});
            case /* CalendarTargetExclamation */9 :
                return React.createElement(make$178, {});
            case /* CalendarTargetExclamationRed */10 :
                return React.createElement(make$179, {});
            case /* CalendarTargetQuestion */11 :
                return React.createElement(make$180, {});
            case /* CaliforniaAB5 */12 :
                return React.createElement(make$181, {});
            case /* Camera */13 :
                return React.createElement(make$182, {});
            case /* ChartGrowth */14 :
                return React.createElement(make$183, {});
            case /* Checklist */15 :
                return React.createElement(make$184, {});
            case /* CircleExclamation */16 :
                return React.createElement(make$185, {});
            case /* CircleInformation */17 :
                return React.createElement(make$186, {});
            case /* CircleQuestion */18 :
                return React.createElement(make$187, {});
            case /* ClockUtensils */19 :
                return React.createElement(make$188, {});
            case /* ClockUtensilSet */20 :
                return React.createElement(make$189, {});
            case /* Community */21 :
                return React.createElement(make$190, {});
            case /* Congrats */22 :
                return React.createElement(make$191, {});
            case /* ConstantlyCurious */23 :
                return React.createElement(make$192, {});
            case /* CreditCard */24 :
                return React.createElement(make$193, {});
            case /* CutRibbon */25 :
                return React.createElement(make$194, {});
            case /* Desktop */26 :
                return React.createElement(make$195, {});
            case /* DesktopLink */27 :
                return React.createElement(make$196, {});
            case /* DesktopWebsite */28 :
                return React.createElement(make$197, {});
            case /* DistanceRoad */29 :
                return React.createElement(make$198, {});
            case /* FindProfessionalsHandsCards */30 :
                return React.createElement(make$202, {});
            case /* Firework */31 :
                return React.createElement(make$203, {});
            case /* FiveStarPentagon */32 :
                return React.createElement(make$204, {});
            case /* FoodBeverageBuilding */33 :
                return React.createElement(make$205, {});
            case /* FoodHandlersCertification */34 :
                return React.createElement(make$206, {});
            case /* FreeToBeUs */35 :
                return React.createElement(make$207, {});
            case /* GPSLocationPin */36 :
                return React.createElement(make$208, {});
            case /* GPSLocationPinRed */37 :
                return React.createElement(make$209, {});
            case /* Growth */38 :
                return React.createElement(make$210, {});
            case /* Handshake */39 :
                return React.createElement(make$211, {});
            case /* HandshakeX */40 :
                return React.createElement(make$212, {});
            case /* HandshakeXRed */41 :
                return React.createElement(make$213, {});
            case /* HeadGears */42 :
                return React.createElement(make$214, {});
            case /* HeartHandshake */43 :
                return React.createElement(make$215, {});
            case /* Hourglass */44 :
                return React.createElement(make$216, {});
            case /* IDBadge */45 :
                return React.createElement(make$217, {});
            case /* Interview */46 :
                return React.createElement(make$218, {});
            case /* Keyboard */47 :
                return React.createElement(make$219, {});
            case /* Laptop */48 :
                return React.createElement(make$220, {});
            case /* Law */49 :
                return React.createElement(make$221, {});
            case /* MakeMoves */50 :
                return React.createElement(make$222, {});
            case /* MapPin */51 :
                return React.createElement(make$223, {});
            case /* MapUSABlank */52 :
                return React.createElement(make$224, {});
            case /* MapUSAFull */53 :
                return React.createElement(make$225, {});
            case /* Mask */54 :
                return React.createElement(make$236, {});
            case /* MaskRed */55 :
                return React.createElement(make$237, {});
            case /* MeetingX */56 :
                return React.createElement(make$238, {});
            case /* Messages */57 :
                return React.createElement(make$239, {});
            case /* MoneyBag */58 :
                return React.createElement(make$240, {});
            case /* MoneyFlowDiagram */59 :
                return React.createElement(make$241, {});
            case /* MoneyHandX */60 :
                return React.createElement(make$242, {});
            case /* NewBadge */61 :
                return React.createElement(make$243, {});
            case /* NotificationBell */62 :
                return React.createElement(make$244, {});
            case /* Orientation */63 :
                return React.createElement(make$245, {});
            case /* PaperShieldCheckmark */64 :
                return React.createElement(make$246, {});
            case /* PeopleGroupAttend */65 :
                return React.createElement(make$247, {});
            case /* PersonX */66 :
                return React.createElement(make$248, {});
            case /* PhoneMessage */67 :
                return React.createElement(make$249, {});
            case /* PhoneNotification */68 :
                return React.createElement(make$250, {});
            case /* PhoneProfile */69 :
                return React.createElement(make$251, {});
            case /* PhoneTouch */70 :
                return React.createElement(make$252, {});
            case /* PINNumber */71 :
                return React.createElement(make$253, {});
            case /* Present */72 :
                return React.createElement(make$254, {});
            case /* Professionals */73 :
                return React.createElement(make$255, {});
            case /* Recruiting */74 :
                return React.createElement(make$256, {});
            case /* RevenueGrowth */75 :
                return React.createElement(make$257, {});
            case /* RobotRound */76 :
                return React.createElement(make$258, {});
            case /* RobotSquare */77 :
                return React.createElement(make$259, {});
            case /* SearchPerson */78 :
                return React.createElement(make$260, {});
            case /* SearchWeb */79 :
                return React.createElement(make$261, {});
            case /* Server */80 :
                return React.createElement(make$262, {});
            case /* ShakerBottleMartini */81 :
                return React.createElement(make$263, {});
            case /* StarAward */82 :
                return React.createElement(make$268, {});
            case /* StopwatchUrgentFast */83 :
                return React.createElement(make$269, {});
            case /* StopwatchUtensils */84 :
                return React.createElement(make$270, {});
            case /* ThumbsRating */85 :
                return React.createElement(make$271, {});
            case /* ThumbsUp */86 :
                return React.createElement(make$272, {});
            case /* TwoHandsShieldCheckmark */87 :
                return React.createElement(make$273, {});
            case /* WorldLocation */88 :
                return React.createElement(make$274, {});
            
          }
        } else {
          switch (match.TAG | 0) {
            case /* DressCode */0 :
                var match$1 = match._0;
                if (typeof match$1 !== "number") {
                  return React.createElement(make$200, {});
                }
                switch (match$1) {
                  case /* BlackOnBlack */0 :
                      return React.createElement(make$199, {});
                  case /* WhiteOnBlack */1 :
                      return React.createElement(make$201, {});
                  case /* Custom */2 :
                      return React.createElement(make$200, {});
                  
                }
            case /* Market */1 :
                switch (match._0) {
                  case /* Arizona */0 :
                      return React.createElement(make$226, {});
                  case /* Atlanta */1 :
                      return React.createElement(make$227, {});
                  case /* Chicago */2 :
                      return React.createElement(make$228, {});
                  case /* Dallas */3 :
                      return React.createElement(make$229, {});
                  case /* Houston */4 :
                      return React.createElement(make$230, {});
                  case /* Miami */5 :
                      return React.createElement(make$231, {});
                  case /* NewJersey */6 :
                      return React.createElement(make$232, {});
                  case /* NewYork */7 :
                      return React.createElement(make$233, {});
                  case /* SanDiego */8 :
                      return React.createElement(make$234, {});
                  case /* TexasAll */9 :
                      return React.createElement(make$235, {});
                  
                }
            case /* Social */2 :
                switch (match._0) {
                  case /* Facebook */0 :
                      return React.createElement(make$264, {});
                  case /* Instagram */1 :
                      return React.createElement(make$265, {});
                  case /* LinkedIn */2 :
                      return React.createElement(make$266, {});
                  case /* Twitter */3 :
                      return React.createElement(make$267, {});
                  
                }
            
          }
        }
    case /* Logo */2 :
        switch (param._0) {
          case /* BusinessDark */0 :
              return React.createElement(make$162, {});
          case /* BusinessDarkVertical */1 :
              return React.createElement(make$163, {});
          case /* BusinessLight */2 :
              return React.createElement(make$164, {});
          case /* BusinessLightVertical */3 :
              return React.createElement(make$165, {});
          case /* Dark */4 :
              return React.createElement(make$166, {});
          case /* I */5 :
              return React.createElement(make$167, {});
          case /* Light */6 :
              return React.createElement(make$168, {});
          
        }
    
  }
}

var getBorderWidth = CommonStyleTypes.Button.getBorderWidth;

function getBorderWidth$1(param) {
  return Relude_Globals.$great$great(getBorderWidth, toRem, param);
}

var useInput = CommonStyleTypes.Input.useInput;

var sizeToHorizontalPadding = CommonStyleTypes.Input.sizeToHorizontalPadding;

var sizeToVerticalPadding = CommonStyleTypes.Input.sizeToVerticalPadding;

var getBorderSize = CommonStyleTypes.Input.getBorderSize;

var borderRadius = Relude_Globals.$great$great(toRemValue, Css.rem, CommonStyleTypes.Input.borderRadius);

var borderWidth = Relude_Globals.$great$great(toRemValue, Css.rem, CommonStyleTypes.Input.borderWidth);

function useInput$1(onFocusOpt) {
  var onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
        return Relude_Globals.$great$great((function (prim) {
                      
                    }), Relude_IO.pure, param);
      });
  var arg = (function (param) {
      return Relude_Globals.$great$great(DomUtils.getFocusActionsFromEvent, onFocus, param);
    });
  return function (param) {
    var func = Curry._1(useInput, param);
    return function (param) {
      return Curry._2(func, param, arg);
    };
  };
}

function sizeToHorizontalPaddingRem(param) {
  return Relude_Globals.$great$great(sizeToHorizontalPadding, toRem, param);
}

function sizeToVerticalPaddingRem(param) {
  return Relude_Globals.$great$great(sizeToVerticalPadding, toRem, param);
}

function sizeToPaddingStyle(size) {
  return Css.padding2(Relude_Globals.$great$great(sizeToVerticalPadding, toRem, size), Relude_Globals.$great$great(sizeToHorizontalPadding, toRem, size));
}

function sizeToPaddingSeparator(size) {
  return Css.padding2(Relude_Globals.$great$great(sizeToVerticalPadding, toRem, size), Css.px(0));
}

function sizeToMarginSeparator(size) {
  return Css.margin2(Css.px(0), Relude_Globals.$great$great(sizeToHorizontalPadding, toRem, size));
}

function getBorderSize$1(param) {
  return Relude_Globals.$great$great(getBorderSize, toRem, param);
}

function withFont(maxNumberOfLines, font, size, weight) {
  var partial_arg = Relude_List.mapOption(Relude_Globals.id, {
        hd: Curry._2(Relude_Option.mapTuple2, (function (maxNumberOfLines, size) {
                var param = Curry._2(multiplyWithFloat, Relude_Int.toFloat(maxNumberOfLines), Curry._1(CommonStyleTypes.Typography.Size.toLineHeightPoint, size));
                return Css.maxHeight(Relude_Globals.$great$great(toRemValue, Css.rem, param));
              }), [
              maxNumberOfLines,
              size
            ]),
        tl: {
          hd: Relude_Option.map((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great(toString, (function (family) {
                                              return {
                                                      NAME: "custom",
                                                      VAL: family
                                                    };
                                            }), param);
                              }), Css.fontFamily, param);
                }), font),
          tl: {
            hd: Relude_Option.map((function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Globals.$great$great(CommonStyleTypes.Typography.Size.toPoint, toRem, param);
                                }), Css.fontSize, param);
                  }), size),
            tl: {
              hd: Relude_Option.map((function (param) {
                      return Relude_Globals.$great$great((function (param) {
                                    return Relude_Globals.$great$great(CommonStyleTypes.Typography.Size.toLineHeightPoint, toRem, param);
                                  }), Css.lineHeight, param);
                    }), size),
              tl: {
                hd: Relude_Option.map((function (param) {
                        return Relude_Globals.$great$great((function (param) {
                                      switch (param) {
                                        case /* Normal */0 :
                                            return Css.normal;
                                        case /* Semibold */1 :
                                            return Css.medium;
                                        case /* Bold */2 :
                                            return Css.bold;
                                        
                                      }
                                    }), Css.fontWeight, param);
                      }), weight),
                tl: /* [] */0
              }
            }
          }
        }
      });
  return function (param) {
    return Relude_List.concat(partial_arg, param);
  };
}

var partial_arg_0 = Css.fontFamily(Css.inherit_);

var partial_arg_1 = {
  hd: Css.fontSize(Css.inherit_),
  tl: {
    hd: Css.lineHeight(Css.inherit_),
    tl: {
      hd: Css.fontWeight(Css.inherit_),
      tl: /* [] */0
    }
  }
};

var partial_arg$6 = {
  hd: partial_arg_0,
  tl: partial_arg_1
};

function inheritFont(param) {
  return Relude_List.concat(partial_arg$6, param);
}

var texturedBackground = Curry._1(Css.style, {
      hd: Css.backgroundAttachment("fixed"),
      tl: {
        hd: Css.backgroundImage(Css.url(qwickWhiteBg)),
        tl: {
          hd: Css.backgroundRepeat("repeat"),
          tl: {
            hd: Css.backgroundSize({
                  NAME: "size",
                  VAL: [
                    Css.rem(45.0),
                    Css.rem(30.0)
                  ]
                }),
            tl: /* [] */0
          }
        }
      }
    });

var texturedDarkBackground = Curry._1(Css.style, {
      hd: Css.backgroundImage(Css.url(qwickDarkBg)),
      tl: {
        hd: Css.backgroundRepeat("noRepeat"),
        tl: {
          hd: Css.backgroundSize("cover"),
          tl: /* [] */0
        }
      }
    });

function mobileMedia(rules) {
  return Css.media("screen and (max-width: 1025px)", rules);
}

function backgroundColor(param) {
  return Relude_Globals.$great$great(toColor, Css.backgroundColor, param);
}

function borderBottom(length, style, color) {
  return Css.borderBottom(length, style, Curry._1(toColor, color));
}

function borderBottomColor(param) {
  return Relude_Globals.$great$great(toColor, Css.borderBottomColor, param);
}

function border(length, style, color) {
  return Css.border(length, style, Curry._1(toColor, color));
}

function borderColor(param) {
  return Relude_Globals.$great$great(toColor, Css.borderColor, param);
}

function borderLeft(length, style, color) {
  return Css.borderLeft(length, style, Curry._1(toColor, color));
}

function borderLeftColor(param) {
  return Relude_Globals.$great$great(toColor, Css.borderLeftColor, param);
}

function borderRight(length, style, color) {
  return Css.borderRight(length, style, Curry._1(toColor, color));
}

function borderRightColor(param) {
  return Relude_Globals.$great$great(toColor, Css.borderRightColor, param);
}

function borderTop(length, style, color) {
  return Css.borderTop(length, style, Curry._1(toColor, color));
}

function borderTopColor(param) {
  return Relude_Globals.$great$great(toColor, Css.borderTopColor, param);
}

function color(param) {
  return Relude_Globals.$great$great(toColor, Css.color, param);
}

function outline(length, style, color) {
  return Css.outline(length, style, Curry._1(toColor, color));
}

function textDecorationColor(param) {
  return Relude_Globals.$great$great(toColor, Css.textDecorationColor, param);
}

var removeBoxShadow = Css.boxShadow(Css.none);

function boxShadow(param) {
  switch (param) {
    case /* XSmall */0 :
        return Css.boxShadow(Curry._6(Css.Shadow.box, Css.zero, Css.zero, Css.rem(0.25), undefined, undefined, Css.rgba(8, 35, 48, 0.24)));
    case /* Small */1 :
        return Css.boxShadow(Curry._6(Css.Shadow.box, Css.zero, Css.zero, Css.rem(0.5), undefined, undefined, Css.rgba(8, 35, 48, 0.24)));
    case /* Medium */2 :
        return Css.boxShadow(Curry._6(Css.Shadow.box, Css.zero, Css.zero, Css.rem(1.0), undefined, undefined, Css.rgba(8, 35, 48, 0.2)));
    case /* Large */3 :
        return Css.boxShadow(Curry._6(Css.Shadow.box, Css.zero, Css.zero, Css.rem(1.5), undefined, undefined, Css.rgba(8, 35, 48, 0.16)));
    case /* XLarge */4 :
        return Css.boxShadow(Curry._6(Css.Shadow.box, Css.zero, Css.zero, Css.rem(2.0), undefined, undefined, Css.rgba(8, 35, 48, 0.12)));
    
  }
}

var fill = Css_Core.SVG.fill;

function fill$1(param) {
  return Relude_Globals.$great$great(toColor, fill, param);
}

function pathSelector(param) {
  return Css.selector("svg path", param);
}

function color$1(color$2) {
  return Css.selector("svg path", {
              hd: Relude_Globals.$great$great(toColor, fill, color$2),
              tl: /* [] */0
            });
}

var SVG_fillRule = Css_Core.SVG.fillRule;

var SVG_fillOpacity = Css_Core.SVG.fillOpacity;

var SVG_stroke = Css_Core.SVG.stroke;

var SVG_strokeLinecap = Css_Core.SVG.strokeLinecap;

var SVG_strokeLinejoin = Css_Core.SVG.strokeLinejoin;

var SVG_strokeMiterlimit = Css_Core.SVG.strokeMiterlimit;

var SVG_strokeWidth = Css_Core.SVG.strokeWidth;

var SVG_strokeOpacity = Css_Core.SVG.strokeOpacity;

var SVG_stopColor = Css_Core.SVG.stopColor;

var SVG_stopOpacity = Css_Core.SVG.stopOpacity;

var SVG = {
  fillRule: SVG_fillRule,
  fillOpacity: SVG_fillOpacity,
  stroke: SVG_stroke,
  strokeLinecap: SVG_strokeLinecap,
  strokeLinejoin: SVG_strokeLinejoin,
  strokeMiterlimit: SVG_strokeMiterlimit,
  strokeWidth: SVG_strokeWidth,
  strokeOpacity: SVG_strokeOpacity,
  stopColor: SVG_stopColor,
  stopOpacity: SVG_stopOpacity,
  fill: fill$1,
  pathSelector: pathSelector,
  color: color$1
};

var Types = Css_AtomicTypes;

var Make = Css.Make;

var toJson = Css.toJson;

var important = Css.important;

var label = Css.label;

var Shadow = Css.Shadow;

var unsafe = Css.unsafe;

var alignContent = Css.alignContent;

var alignItems = Css.alignItems;

var alignSelf = Css.alignSelf;

var animationDelay = Css.animationDelay;

var animationDirection = Css.animationDirection;

var animationDuration = Css.animationDuration;

var animationFillMode = Css.animationFillMode;

var animationIterationCount = Css.animationIterationCount;

var animationPlayState = Css.animationPlayState;

var animationTimingFunction = Css.animationTimingFunction;

var backdropFilter = Css.backdropFilter;

var backfaceVisibility = Css.backfaceVisibility;

var backgroundAttachment = Css.backgroundAttachment;

var backgroundClip = Css.backgroundClip;

var backgroundImage = Css.backgroundImage;

var backgroundOrigin = Css.backgroundOrigin;

var backgroundPosition = Css.backgroundPosition;

var backgroundPositions = Css.backgroundPositions;

var backgroundPosition4 = Css.backgroundPosition4;

var backgroundRepeat = Css.backgroundRepeat;

var borderBottomLeftRadius = Css.borderBottomLeftRadius;

var borderBottomRightRadius = Css.borderBottomRightRadius;

var borderBottomStyle = Css.borderBottomStyle;

var borderBottomWidth = Css.borderBottomWidth;

var borderCollapse = Css.borderCollapse;

var borderLeftStyle = Css.borderLeftStyle;

var borderLeftWidth = Css.borderLeftWidth;

var borderRightStyle = Css.borderRightStyle;

var borderRightWidth = Css.borderRightWidth;

var borderRadius$1 = Css.borderRadius;

var borderSpacing = Css.borderSpacing;

var borderStyle = Css.borderStyle;

var borderTopLeftRadius = Css.borderTopLeftRadius;

var borderTopRightRadius = Css.borderTopRightRadius;

var borderTopStyle = Css.borderTopStyle;

var borderTopWidth = Css.borderTopWidth;

var borderWidth$1 = Css.borderWidth;

var bottom = Css.bottom;

var boxSizing = Css.boxSizing;

var clear = Css.clear;

var clipPath = Css.clipPath;

var columnCount = Css.columnCount;

var contentRule = Css.contentRule;

var contentRules = Css.contentRules;

var counterIncrement = Css.counterIncrement;

var countersIncrement = Css.countersIncrement;

var counterReset = Css.counterReset;

var countersReset = Css.countersReset;

var counterSet = Css.counterSet;

var countersSet = Css.countersSet;

var cursor = Css.cursor;

var direction = Css.direction;

var display = Css.display;

var flex = Css.flex;

var flexBasis = Css.flexBasis;

var flexDirection = Css.flexDirection;

var flexGrow = Css.flexGrow;

var flexShrink = Css.flexShrink;

var flexWrap = Css.flexWrap;

var $$float = Css.$$float;

var fontStyle = Css.fontStyle;

var fontVariant = Css.fontVariant;

var gridArea = Css.gridArea;

var gridArea2 = Css.gridArea2;

var gridArea3 = Css.gridArea3;

var gridArea4 = Css.gridArea4;

var gridAutoFlow = Css.gridAutoFlow;

var gridColumn = Css.gridColumn;

var gridColumnEnd = Css.gridColumnEnd;

var gridColumnGap = Css.gridColumnGap;

var gridColumnStart = Css.gridColumnStart;

var gridGap = Css.gridGap;

var gridRow = Css.gridRow;

var gridRowEnd = Css.gridRowEnd;

var gridRowGap = Css.gridRowGap;

var gridRowStart = Css.gridRowStart;

var gridTemplateAreas = Css.gridTemplateAreas;

var height = Css.height;

var justifyContent = Css.justifyContent;

var justifySelf = Css.justifySelf;

var left = Css.left;

var letterSpacing = Css.letterSpacing;

var listStyle = Css.listStyle;

var listStyleImage = Css.listStyleImage;

var listStyleType = Css.listStyleType;

var listStylePosition = Css.listStylePosition;

var margin = Css.margin;

var margin2 = Css.margin2;

var margin3 = Css.margin3;

var margin4 = Css.margin4;

var marginLeft = Css.marginLeft;

var marginRight = Css.marginRight;

var marginTop = Css.marginTop;

var marginBottom = Css.marginBottom;

var maxHeight = Css.maxHeight;

var maxWidth = Css.maxWidth;

var minHeight = Css.minHeight;

var minWidth = Css.minWidth;

var objectFit = Css.objectFit;

var objectPosition = Css.objectPosition;

var opacity = Css.opacity;

var order = Css.order;

var outlineColor = Css.outlineColor;

var outlineOffset = Css.outlineOffset;

var outlineStyle = Css.outlineStyle;

var outlineWidth = Css.outlineWidth;

var overflow = Css.overflow;

var overflowX = Css.overflowX;

var overflowY = Css.overflowY;

var overflowWrap = Css.overflowWrap;

var padding = Css.padding;

var padding2 = Css.padding2;

var padding3 = Css.padding3;

var padding4 = Css.padding4;

var paddingLeft = Css.paddingLeft;

var paddingRight = Css.paddingRight;

var paddingTop = Css.paddingTop;

var paddingBottom = Css.paddingBottom;

var perspective = Css.perspective;

var perspectiveOrigin = Css.perspectiveOrigin;

var pointerEvents = Css.pointerEvents;

var position = Css.position;

var resize = Css.resize;

var right = Css.right;

var tableLayout = Css.tableLayout;

var textAlign = Css.textAlign;

var textDecorationLine = Css.textDecorationLine;

var textDecorationStyle = Css.textDecorationStyle;

var textIndent = Css.textIndent;

var textOverflow = Css.textOverflow;

var textShadow = Css.textShadow;

var textShadows = Css.textShadows;

var textTransform = Css.textTransform;

var top = Css.top;

var transform = Css.transform;

var transforms = Css.transforms;

var transformOrigin = Css.transformOrigin;

var transformOrigin3d = Css.transformOrigin3d;

var transitionDelay = Css.transitionDelay;

var transitionDuration = Css.transitionDuration;

var transitionProperty = Css.transitionProperty;

var transformStyle = Css.transformStyle;

var transitionTimingFunction = Css.transitionTimingFunction;

var userSelect = Css.userSelect;

var verticalAlign = Css.verticalAlign;

var visibility = Css.visibility;

var width = Css.width;

var whiteSpace = Css.whiteSpace;

var wordBreak = Css.wordBreak;

var wordSpacing = Css.wordSpacing;

var wordWrap = Css.wordWrap;

var zIndex = Css.zIndex;

var selector = Css.selector;

var media = Css.media;

var active = Css.active;

var checked = Css.checked;

var $$default = Css.$$default;

var defined = Css.defined;

var disabled = Css.disabled;

var empty = Css.empty;

var enabled = Css.enabled;

var first = Css.first;

var firstChild = Css.firstChild;

var firstOfType = Css.firstOfType;

var focus = Css.focus;

var focusWithin = Css.focusWithin;

var host = Css.host;

var hover = Css.hover;

var indeterminate = Css.indeterminate;

var inRange = Css.inRange;

var invalid = Css.invalid;

var lang = Css.lang;

var lastChild = Css.lastChild;

var lastOfType = Css.lastOfType;

var link = Css.link;

var not__ = Css.not__;

var Nth = Css.Nth;

var nthChild = Css.nthChild;

var nthLastChild = Css.nthLastChild;

var nthLastOfType = Css.nthLastOfType;

var nthOfType = Css.nthOfType;

var onlyChild = Css.onlyChild;

var onlyOfType = Css.onlyOfType;

var optional = Css.optional;

var outOfRange = Css.outOfRange;

var readOnly = Css.readOnly;

var readWrite = Css.readWrite;

var required = Css.required;

var root = Css.root;

var scope = Css.scope;

var target = Css.target;

var valid = Css.valid;

var visited = Css.visited;

var after = Css.after;

var before = Css.before;

var firstLetter = Css.firstLetter;

var firstLine = Css.firstLine;

var placeholder = Css.placeholder;

var selection = Css.selection;

var child = Css.child;

var children = Css.children;

var directSibling = Css.directSibling;

var siblings = Css.siblings;

var anyLink = Css.anyLink;

var initial = Css.initial;

var inherit_ = Css.inherit_;

var unset = Css.unset;

var auto = Css.auto;

var none = Css.none;

var text = Css.text;

var pct = Css.pct;

var ch = Css.ch;

var cm = Css.cm;

var em = Css.em;

var ex = Css.ex;

var mm = Css.mm;

var pt = Css.pt;

var px = Css.px;

var pxFloat = Css.pxFloat;

var rem = Css.rem;

var vh = Css.vh;

var vmin = Css.vmin;

var vmax = Css.vmax;

var zero = Css.zero;

var deg = Css.deg;

var rad = Css.rad;

var grad = Css.grad;

var turn = Css.turn;

var ltr = Css.ltr;

var rtl = Css.rtl;

var absolute = Css.absolute;

var relative = Css.relative;

var $$static = Css.$$static;

var fixed = Css.fixed;

var sticky = Css.sticky;

var horizontal = Css.horizontal;

var vertical = Css.vertical;

var smallCaps = Css.smallCaps;

var italic = Css.italic;

var oblique = Css.oblique;

var hidden = Css.hidden;

var visible = Css.visible;

var scroll = Css.scroll;

var rgb = Css.rgb;

var rgba = Css.rgba;

var hsl = Css.hsl;

var hsla = Css.hsla;

var hex = Css.hex;

var transparent = Css.transparent;

var currentColor = Css.currentColor;

var local = Css.local;

var paddingBox = Css.paddingBox;

var borderBox = Css.borderBox;

var contentBox = Css.contentBox;

var noRepeat = Css.noRepeat;

var space = Css.space;

var repeat = Css.repeat;

var minmax = Css.minmax;

var repeatX = Css.repeatX;

var repeatY = Css.repeatY;

var contain = Css.contain;

var cover = Css.cover;

var row = Css.row;

var rowReverse = Css.rowReverse;

var column = Css.column;

var columnReverse = Css.columnReverse;

var wrap = Css.wrap;

var nowrap = Css.nowrap;

var wrapReverse = Css.wrapReverse;

var inline = Css.inline;

var block = Css.block;

var contents = Css.contents;

var flexBox = Css.flexBox;

var grid = Css.grid;

var inlineBlock = Css.inlineBlock;

var inlineFlex = Css.inlineFlex;

var inlineGrid = Css.inlineGrid;

var inlineTable = Css.inlineTable;

var listItem = Css.listItem;

var runIn = Css.runIn;

var table = Css.table;

var tableCaption = Css.tableCaption;

var tableColumnGroup = Css.tableColumnGroup;

var tableHeaderGroup = Css.tableHeaderGroup;

var tableFooterGroup = Css.tableFooterGroup;

var tableRowGroup = Css.tableRowGroup;

var tableCell = Css.tableCell;

var tableColumn = Css.tableColumn;

var tableRow = Css.tableRow;

var flexStart = Css.flexStart;

var flexEnd = Css.flexEnd;

var center = Css.center;

var stretch = Css.stretch;

var spaceBetween = Css.spaceBetween;

var spaceAround = Css.spaceAround;

var spaceEvenly = Css.spaceEvenly;

var baseline = Css.baseline;

var forwards = Css.forwards;

var backwards = Css.backwards;

var both = Css.both;

var infinite = Css.infinite;

var count = Css.count;

var paused = Css.paused;

var running = Css.running;

var inside = Css.inside;

var outside = Css.outside;

var solid = Css.solid;

var dotted = Css.dotted;

var dashed = Css.dashed;

var underline = Css.underline;

var overline = Css.overline;

var lineThrough = Css.lineThrough;

var clip = Css.clip;

var ellipsis = Css.ellipsis;

var wavy = Css.wavy;

var $$double = Css.$$double;

var uppercase = Css.uppercase;

var lowercase = Css.lowercase;

var capitalize = Css.capitalize;

var sub = Css.sub;

var $$super = Css.$$super;

var textTop = Css.textTop;

var textBottom = Css.textBottom;

var middle = Css.middle;

var normal = Css.normal;

var breakAll = Css.breakAll;

var keepAll = Css.keepAll;

var breakWord = Css.breakWord;

var reverse = Css.reverse;

var alternate = Css.alternate;

var alternateReverse = Css.alternateReverse;

var fill$2 = Css.fill;

var content = Css.content;

var maxContent = Css.maxContent;

var minContent = Css.minContent;

var fitContent = Css.fitContent;

var all = Css.all;

var round = Css.round;

var miter = Css.miter;

var bevel = Css.bevel;

var butt = Css.butt;

var square = Css.square;

var thin = Css.thin;

var extraLight = Css.extraLight;

var light = Css.light;

var medium = Css.medium;

var semiBold = Css.semiBold;

var bold = Css.bold;

var extraBold = Css.extraBold;

var lighter = Css.lighter;

var bolder = Css.bolder;

var fr = Css.fr;

var vw = Css.vw;

var localUrl = Css.localUrl;

var url = Css.url;

var linear = Css.linear;

var ease = Css.ease;

var easeIn = Css.easeIn;

var easeOut = Css.easeOut;

var easeInOut = Css.easeInOut;

var stepStart = Css.stepStart;

var stepEnd = Css.stepEnd;

var steps = Css.steps;

var cubicBezier = Css.cubicBezier;

var marginBox = Css.marginBox;

var fillBox = Css.fillBox;

var strokeBox = Css.strokeBox;

var viewBox = Css.viewBox;

var translate = Css.translate;

var translate3d = Css.translate3d;

var translateX = Css.translateX;

var translateY = Css.translateY;

var translateZ = Css.translateZ;

var scale = Css.scale;

var scale3d = Css.scale3d;

var scaleX = Css.scaleX;

var scaleY = Css.scaleY;

var scaleZ = Css.scaleZ;

var rotate = Css.rotate;

var rotate3d = Css.rotate3d;

var rotateX = Css.rotateX;

var rotateY = Css.rotateY;

var rotateZ = Css.rotateZ;

var skew = Css.skew;

var skewX = Css.skewX;

var skewY = Css.skewY;

var linearGradient = Css.linearGradient;

var repeatingLinearGradient = Css.repeatingLinearGradient;

var radialGradient = Css.radialGradient;

var repeatingRadialGradient = Css.repeatingRadialGradient;

var areas = Css.areas;

var ident = Css.ident;

var numIdent = Css.numIdent;

var contextMenu = Css.contextMenu;

var help = Css.help;

var pointer = Css.pointer;

var progress = Css.progress;

var wait = Css.wait;

var cell = Css.cell;

var crosshair = Css.crosshair;

var verticalText = Css.verticalText;

var alias = Css.alias;

var copy = Css.copy;

var move = Css.move;

var noDrop = Css.noDrop;

var notAllowed = Css.notAllowed;

var grab = Css.grab;

var grabbing = Css.grabbing;

var allScroll = Css.allScroll;

var colResize = Css.colResize;

var rowResize = Css.rowResize;

var nResize = Css.nResize;

var eResize = Css.eResize;

var sResize = Css.sResize;

var wResize = Css.wResize;

var neResize = Css.neResize;

var nwResize = Css.nwResize;

var seResize = Css.seResize;

var swResize = Css.swResize;

var ewResize = Css.ewResize;

var nsResize = Css.nsResize;

var neswResize = Css.neswResize;

var nwseResize = Css.nwseResize;

var zoomIn = Css.zoomIn;

var zoomOut = Css.zoomOut;

var flex3 = Css.flex3;

var backgroundSize = Css.backgroundSize;

var textDecoration = Css.textDecoration;

var background = Css.background;

var backgrounds = Css.backgrounds;

var gridAutoColumns = Css.gridAutoColumns;

var gridAutoRows = Css.gridAutoRows;

var gridTemplateColumns = Css.gridTemplateColumns;

var gridTemplateRows = Css.gridTemplateRows;

var Calc = Css.Calc;

var size = Css.size;

var filter = Css.filter;

var Transition = Css.Transition;

var transitionValue = Css.transitionValue;

var transitionList = Css.transitionList;

var transition = Css.transition;

var transitions = Css.transitions;

var Animation = Css.Animation;

var animationValue = Css.animationValue;

var animation = Css.animation;

var animations = Css.animations;

var animationName = Css.animationName;

var aliceblue = Css.aliceblue;

var antiquewhite = Css.antiquewhite;

var aqua = Css.aqua;

var aquamarine = Css.aquamarine;

var azure = Css.azure;

var beige = Css.beige;

var bisque = Css.bisque;

var black = Css.black;

var blanchedalmond = Css.blanchedalmond;

var blue = Css.blue;

var blueviolet = Css.blueviolet;

var brown = Css.brown;

var burlywood = Css.burlywood;

var cadetblue = Css.cadetblue;

var chartreuse = Css.chartreuse;

var chocolate = Css.chocolate;

var coral = Css.coral;

var cornflowerblue = Css.cornflowerblue;

var cornsilk = Css.cornsilk;

var crimson = Css.crimson;

var cyan = Css.cyan;

var darkblue = Css.darkblue;

var darkcyan = Css.darkcyan;

var darkgoldenrod = Css.darkgoldenrod;

var darkgray = Css.darkgray;

var darkgrey = Css.darkgrey;

var darkgreen = Css.darkgreen;

var darkkhaki = Css.darkkhaki;

var darkmagenta = Css.darkmagenta;

var darkolivegreen = Css.darkolivegreen;

var darkorange = Css.darkorange;

var darkorchid = Css.darkorchid;

var darkred = Css.darkred;

var darksalmon = Css.darksalmon;

var darkseagreen = Css.darkseagreen;

var darkslateblue = Css.darkslateblue;

var darkslategray = Css.darkslategray;

var darkslategrey = Css.darkslategrey;

var darkturquoise = Css.darkturquoise;

var darkviolet = Css.darkviolet;

var deeppink = Css.deeppink;

var deepskyblue = Css.deepskyblue;

var dimgray = Css.dimgray;

var dimgrey = Css.dimgrey;

var dodgerblue = Css.dodgerblue;

var firebrick = Css.firebrick;

var floralwhite = Css.floralwhite;

var forestgreen = Css.forestgreen;

var fuchsia = Css.fuchsia;

var gainsboro = Css.gainsboro;

var ghostwhite = Css.ghostwhite;

var gold = Css.gold;

var goldenrod = Css.goldenrod;

var gray = Css.gray;

var grey = Css.grey;

var green = Css.green;

var greenyellow = Css.greenyellow;

var honeydew = Css.honeydew;

var hotpink = Css.hotpink;

var indianred = Css.indianred;

var indigo = Css.indigo;

var ivory = Css.ivory;

var khaki = Css.khaki;

var lavender = Css.lavender;

var lavenderblush = Css.lavenderblush;

var lawngreen = Css.lawngreen;

var lemonchiffon = Css.lemonchiffon;

var lightblue = Css.lightblue;

var lightcoral = Css.lightcoral;

var lightcyan = Css.lightcyan;

var lightgoldenrodyellow = Css.lightgoldenrodyellow;

var lightgray = Css.lightgray;

var lightgrey = Css.lightgrey;

var lightgreen = Css.lightgreen;

var lightpink = Css.lightpink;

var lightsalmon = Css.lightsalmon;

var lightseagreen = Css.lightseagreen;

var lightskyblue = Css.lightskyblue;

var lightslategray = Css.lightslategray;

var lightslategrey = Css.lightslategrey;

var lightsteelblue = Css.lightsteelblue;

var lightyellow = Css.lightyellow;

var lime = Css.lime;

var limegreen = Css.limegreen;

var linen = Css.linen;

var magenta = Css.magenta;

var maroon = Css.maroon;

var mediumaquamarine = Css.mediumaquamarine;

var mediumblue = Css.mediumblue;

var mediumorchid = Css.mediumorchid;

var mediumpurple = Css.mediumpurple;

var mediumseagreen = Css.mediumseagreen;

var mediumslateblue = Css.mediumslateblue;

var mediumspringgreen = Css.mediumspringgreen;

var mediumturquoise = Css.mediumturquoise;

var mediumvioletred = Css.mediumvioletred;

var midnightblue = Css.midnightblue;

var mintcream = Css.mintcream;

var mistyrose = Css.mistyrose;

var moccasin = Css.moccasin;

var navajowhite = Css.navajowhite;

var navy = Css.navy;

var oldlace = Css.oldlace;

var olive = Css.olive;

var olivedrab = Css.olivedrab;

var orange = Css.orange;

var orangered = Css.orangered;

var orchid = Css.orchid;

var palegoldenrod = Css.palegoldenrod;

var palegreen = Css.palegreen;

var paleturquoise = Css.paleturquoise;

var palevioletred = Css.palevioletred;

var papayawhip = Css.papayawhip;

var peachpuff = Css.peachpuff;

var peru = Css.peru;

var pink = Css.pink;

var plum = Css.plum;

var powderblue = Css.powderblue;

var purple = Css.purple;

var rebeccapurple = Css.rebeccapurple;

var red = Css.red;

var rosybrown = Css.rosybrown;

var royalblue = Css.royalblue;

var saddlebrown = Css.saddlebrown;

var salmon = Css.salmon;

var sandybrown = Css.sandybrown;

var seagreen = Css.seagreen;

var seashell = Css.seashell;

var sienna = Css.sienna;

var silver = Css.silver;

var skyblue = Css.skyblue;

var slateblue = Css.slateblue;

var slategray = Css.slategray;

var slategrey = Css.slategrey;

var snow = Css.snow;

var springgreen = Css.springgreen;

var steelblue = Css.steelblue;

var tan = Css.tan;

var teal = Css.teal;

var thistle = Css.thistle;

var tomato = Css.tomato;

var turquoise = Css.turquoise;

var violet = Css.violet;

var wheat = Css.wheat;

var white = Css.white;

var whitesmoke = Css.whitesmoke;

var yellow = Css.yellow;

var yellowgreen = Css.yellowgreen;

var $$global = Css.$$global;

var insertRule = Css.insertRule;

var merge = Css.merge;

var style = Css.style;

var keyframes = Css.keyframes;

var fontFace = Css.fontFace;

var Point_fromString = CommonStyleTypes.Point.fromString;

var Point_toString = CommonStyleTypes.Point.toString;

var Point_decode = CommonStyleTypes.Point.decode;

var Point_encode = CommonStyleTypes.Point.encode;

var Point_compare = CommonStyleTypes.Point.compare;

var Point_eq = CommonStyleTypes.Point.eq;

var Point_Ord = CommonStyleTypes.Point.Ord;

var Point_Set = CommonStyleTypes.Point.$$Set;

var Point_Map = CommonStyleTypes.Point.$$Map;

var Point_fromFloat = CommonStyleTypes.Point.fromFloat;

var Point_add = CommonStyleTypes.Point.add;

var Point_subtract = CommonStyleTypes.Point.subtract;

var Point_multiply = CommonStyleTypes.Point.multiply;

var Point_divide = CommonStyleTypes.Point.divide;

var Point_addFloat = CommonStyleTypes.Point.addFloat;

var Point_subtractFloat = CommonStyleTypes.Point.subtractFloat;

var Point_divideFloat = CommonStyleTypes.Point.divideFloat;

var Point = {
  fromString: Point_fromString,
  toFloat: toFloat,
  toString: Point_toString,
  decode: Point_decode,
  encode: Point_encode,
  compare: Point_compare,
  eq: Point_eq,
  Ord: Point_Ord,
  $$Set: Point_Set,
  $$Map: Point_Map,
  fromFloat: Point_fromFloat,
  add: Point_add,
  subtract: Point_subtract,
  multiply: Point_multiply,
  divide: Point_divide,
  addFloat: Point_addFloat,
  subtractFloat: Point_subtractFloat,
  multiplyWithFloat: multiplyWithFloat,
  divideFloat: Point_divideFloat,
  convertToUnit: convertToUnit,
  toRemValue: toRemValue,
  toRem: toRem,
  toPx: toPx,
  toRawPxValue: toRawPxValue
};

var Theme;

var Box = CommonStyleTypes.Box;

var Elevation;

var Color_Intensity = CommonStyleTypes.Color.Intensity;

var Color_IntensityPartial = CommonStyleTypes.Color.IntensityPartial;

var Color = {
  Intensity: Color_Intensity,
  IntensityPartial: Color_IntensityPartial,
  toColor: toColor,
  toString: toString$1,
  tToRgba: tToRgba
};

var Icon_Large = CommonStyleTypes.Icon.Large;

var Icon_Small = CommonStyleTypes.Icon.Small;

var Icon_Size = CommonStyleTypes.Icon.Size;

var Icon_toBoxSize = CommonStyleTypes.Icon.toBoxSize;

var Icon_isFullColor = CommonStyleTypes.Icon.isFullColor;

var Icon = {
  Large: Icon_Large,
  Small: Icon_Small,
  Size: Icon_Size,
  sizeToRem: sizeToRem,
  toBoxSize: Icon_toBoxSize,
  isFullColor: Icon_isFullColor,
  toElement: toElement
};

var Image_Blob = CommonStyleTypes.$$Image.$$Blob;

var Image_Illustration = CommonStyleTypes.$$Image.Illustration;

var Image_Logo = CommonStyleTypes.$$Image.Logo;

var Image_toBoxSize = CommonStyleTypes.$$Image.toBoxSize;

var $$Image = {
  $$Blob: Image_Blob,
  Illustration: Image_Illustration,
  Logo: Image_Logo,
  toBoxSize: Image_toBoxSize,
  toElement: toElement$1,
  heroBusiness: heroBusiness,
  heroProfessional: heroProfessional,
  pencilIcon: pencilIcon,
  qwickDarkBg: qwickDarkBg,
  qwickIcon: qwickIcon,
  qwickIconSq: qwickIconSq,
  qwickWhiteBg: qwickWhiteBg,
  robotIcon: robotIcon,
  zapIcon: zapIcon
};

var Button_ActionPriority = CommonStyleTypes.Button.ActionPriority;

var Button_FocusState = CommonStyleTypes.Button.FocusState;

var Button_InteractionState = CommonStyleTypes.Button.InteractionState;

var Button_Size = CommonStyleTypes.Button.Size;

var Button_toBackgroundColor = CommonStyleTypes.Button.toBackgroundColor;

var Button_toBorderColor = CommonStyleTypes.Button.toBorderColor;

var Button_toTextColor = CommonStyleTypes.Button.toTextColor;

var Button_sizeToFontSize = CommonStyleTypes.Button.sizeToFontSize;

var Button = {
  ActionPriority: Button_ActionPriority,
  FocusState: Button_FocusState,
  InteractionState: Button_InteractionState,
  Size: Button_Size,
  toBackgroundColor: Button_toBackgroundColor,
  toBorderColor: Button_toBorderColor,
  getBorderWidth: getBorderWidth$1,
  toTextColor: Button_toTextColor,
  sizeToFontSize: Button_sizeToFontSize
};

var Input_Size = CommonStyleTypes.Input.Size;

var Input_FocusState = CommonStyleTypes.Input.FocusState;

var Input_ValidationStatus = CommonStyleTypes.Input.ValidationStatus;

var Input_isDisabled = CommonStyleTypes.Input.isDisabled;

var Input_sizeToTitleFontSize = CommonStyleTypes.Input.sizeToTitleFontSize;

var Input_sizeToFontSize = CommonStyleTypes.Input.sizeToFontSize;

var Input_getTitleColor = CommonStyleTypes.Input.getTitleColor;

var Input_getTextColor = CommonStyleTypes.Input.getTextColor;

var Input_getHintColor = CommonStyleTypes.Input.getHintColor;

var Input_getBorderColor = CommonStyleTypes.Input.getBorderColor;

var Input_getBackgroundColor = CommonStyleTypes.Input.getBackgroundColor;

var Input_sizeToIconSize = CommonStyleTypes.Input.sizeToIconSize;

var Input = {
  Size: Input_Size,
  FocusState: Input_FocusState,
  ValidationStatus: Input_ValidationStatus,
  isDisabled: Input_isDisabled,
  sizeToHorizontalPadding: sizeToHorizontalPadding,
  sizeToVerticalPadding: sizeToVerticalPadding,
  sizeToTitleFontSize: Input_sizeToTitleFontSize,
  borderRadius: borderRadius,
  borderWidth: borderWidth,
  useInput: useInput$1,
  sizeToHorizontalPaddingRem: sizeToHorizontalPaddingRem,
  sizeToVerticalPaddingRem: sizeToVerticalPaddingRem,
  sizeToPaddingSeparator: sizeToPaddingSeparator,
  sizeToPaddingStyle: sizeToPaddingStyle,
  sizeToMarginSeparator: sizeToMarginSeparator,
  sizeToFontSize: Input_sizeToFontSize,
  getBorderSize: getBorderSize$1,
  getTitleColor: Input_getTitleColor,
  getTextColor: Input_getTextColor,
  getHintColor: Input_getHintColor,
  getBorderColor: Input_getBorderColor,
  getBackgroundColor: Input_getBackgroundColor,
  sizeToIconSize: Input_sizeToIconSize
};

var fontWeight;

var fontFamily;

var fontFamilies;

var fontSize;

var lineHeight;

var boxShadows;

exports.Types = Types;
exports.Make = Make;
exports.toJson = toJson;
exports.important = important;
exports.label = label;
exports.Shadow = Shadow;
exports.unsafe = unsafe;
exports.alignContent = alignContent;
exports.alignItems = alignItems;
exports.alignSelf = alignSelf;
exports.animationDelay = animationDelay;
exports.animationDirection = animationDirection;
exports.animationDuration = animationDuration;
exports.animationFillMode = animationFillMode;
exports.animationIterationCount = animationIterationCount;
exports.animationPlayState = animationPlayState;
exports.animationTimingFunction = animationTimingFunction;
exports.backdropFilter = backdropFilter;
exports.backfaceVisibility = backfaceVisibility;
exports.backgroundAttachment = backgroundAttachment;
exports.backgroundClip = backgroundClip;
exports.backgroundImage = backgroundImage;
exports.backgroundOrigin = backgroundOrigin;
exports.backgroundPosition = backgroundPosition;
exports.backgroundPositions = backgroundPositions;
exports.backgroundPosition4 = backgroundPosition4;
exports.backgroundRepeat = backgroundRepeat;
exports.borderBottomLeftRadius = borderBottomLeftRadius;
exports.borderBottomRightRadius = borderBottomRightRadius;
exports.borderBottomStyle = borderBottomStyle;
exports.borderBottomWidth = borderBottomWidth;
exports.borderCollapse = borderCollapse;
exports.borderLeftStyle = borderLeftStyle;
exports.borderLeftWidth = borderLeftWidth;
exports.borderRightStyle = borderRightStyle;
exports.borderRightWidth = borderRightWidth;
exports.borderRadius = borderRadius$1;
exports.borderSpacing = borderSpacing;
exports.borderStyle = borderStyle;
exports.borderTopLeftRadius = borderTopLeftRadius;
exports.borderTopRightRadius = borderTopRightRadius;
exports.borderTopStyle = borderTopStyle;
exports.borderTopWidth = borderTopWidth;
exports.borderWidth = borderWidth$1;
exports.bottom = bottom;
exports.boxSizing = boxSizing;
exports.clear = clear;
exports.clipPath = clipPath;
exports.columnCount = columnCount;
exports.contentRule = contentRule;
exports.contentRules = contentRules;
exports.counterIncrement = counterIncrement;
exports.countersIncrement = countersIncrement;
exports.counterReset = counterReset;
exports.countersReset = countersReset;
exports.counterSet = counterSet;
exports.countersSet = countersSet;
exports.cursor = cursor;
exports.direction = direction;
exports.display = display;
exports.flex = flex;
exports.flexBasis = flexBasis;
exports.flexDirection = flexDirection;
exports.flexGrow = flexGrow;
exports.flexShrink = flexShrink;
exports.flexWrap = flexWrap;
exports.$$float = $$float;
exports.fontStyle = fontStyle;
exports.fontVariant = fontVariant;
exports.gridArea = gridArea;
exports.gridArea2 = gridArea2;
exports.gridArea3 = gridArea3;
exports.gridArea4 = gridArea4;
exports.gridAutoFlow = gridAutoFlow;
exports.gridColumn = gridColumn;
exports.gridColumnEnd = gridColumnEnd;
exports.gridColumnGap = gridColumnGap;
exports.gridColumnStart = gridColumnStart;
exports.gridGap = gridGap;
exports.gridRow = gridRow;
exports.gridRowEnd = gridRowEnd;
exports.gridRowGap = gridRowGap;
exports.gridRowStart = gridRowStart;
exports.gridTemplateAreas = gridTemplateAreas;
exports.height = height;
exports.justifyContent = justifyContent;
exports.justifySelf = justifySelf;
exports.left = left;
exports.letterSpacing = letterSpacing;
exports.listStyle = listStyle;
exports.listStyleImage = listStyleImage;
exports.listStyleType = listStyleType;
exports.listStylePosition = listStylePosition;
exports.margin = margin;
exports.margin2 = margin2;
exports.margin3 = margin3;
exports.margin4 = margin4;
exports.marginLeft = marginLeft;
exports.marginRight = marginRight;
exports.marginTop = marginTop;
exports.marginBottom = marginBottom;
exports.maxHeight = maxHeight;
exports.maxWidth = maxWidth;
exports.minHeight = minHeight;
exports.minWidth = minWidth;
exports.objectFit = objectFit;
exports.objectPosition = objectPosition;
exports.opacity = opacity;
exports.order = order;
exports.outlineColor = outlineColor;
exports.outlineOffset = outlineOffset;
exports.outlineStyle = outlineStyle;
exports.outlineWidth = outlineWidth;
exports.overflow = overflow;
exports.overflowX = overflowX;
exports.overflowY = overflowY;
exports.overflowWrap = overflowWrap;
exports.padding = padding;
exports.padding2 = padding2;
exports.padding3 = padding3;
exports.padding4 = padding4;
exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.paddingTop = paddingTop;
exports.paddingBottom = paddingBottom;
exports.perspective = perspective;
exports.perspectiveOrigin = perspectiveOrigin;
exports.pointerEvents = pointerEvents;
exports.position = position;
exports.resize = resize;
exports.right = right;
exports.tableLayout = tableLayout;
exports.textAlign = textAlign;
exports.textDecorationLine = textDecorationLine;
exports.textDecorationStyle = textDecorationStyle;
exports.textIndent = textIndent;
exports.textOverflow = textOverflow;
exports.textShadow = textShadow;
exports.textShadows = textShadows;
exports.textTransform = textTransform;
exports.top = top;
exports.transform = transform;
exports.transforms = transforms;
exports.transformOrigin = transformOrigin;
exports.transformOrigin3d = transformOrigin3d;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
exports.transformStyle = transformStyle;
exports.transitionTimingFunction = transitionTimingFunction;
exports.userSelect = userSelect;
exports.verticalAlign = verticalAlign;
exports.visibility = visibility;
exports.width = width;
exports.whiteSpace = whiteSpace;
exports.wordBreak = wordBreak;
exports.wordSpacing = wordSpacing;
exports.wordWrap = wordWrap;
exports.zIndex = zIndex;
exports.selector = selector;
exports.media = media;
exports.active = active;
exports.checked = checked;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.defined = defined;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.focus = focus;
exports.focusWithin = focusWithin;
exports.host = host;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lang = lang;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.link = link;
exports.not__ = not__;
exports.Nth = Nth;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.placeholder = placeholder;
exports.selection = selection;
exports.child = child;
exports.children = children;
exports.directSibling = directSibling;
exports.siblings = siblings;
exports.anyLink = anyLink;
exports.initial = initial;
exports.inherit_ = inherit_;
exports.unset = unset;
exports.auto = auto;
exports.none = none;
exports.text = text;
exports.pct = pct;
exports.ch = ch;
exports.cm = cm;
exports.em = em;
exports.ex = ex;
exports.mm = mm;
exports.pt = pt;
exports.px = px;
exports.pxFloat = pxFloat;
exports.rem = rem;
exports.vh = vh;
exports.vmin = vmin;
exports.vmax = vmax;
exports.zero = zero;
exports.deg = deg;
exports.rad = rad;
exports.grad = grad;
exports.turn = turn;
exports.ltr = ltr;
exports.rtl = rtl;
exports.absolute = absolute;
exports.relative = relative;
exports.$$static = $$static;
exports.fixed = fixed;
exports.sticky = sticky;
exports.horizontal = horizontal;
exports.vertical = vertical;
exports.smallCaps = smallCaps;
exports.italic = italic;
exports.oblique = oblique;
exports.hidden = hidden;
exports.visible = visible;
exports.scroll = scroll;
exports.rgb = rgb;
exports.rgba = rgba;
exports.hsl = hsl;
exports.hsla = hsla;
exports.hex = hex;
exports.transparent = transparent;
exports.currentColor = currentColor;
exports.local = local;
exports.paddingBox = paddingBox;
exports.borderBox = borderBox;
exports.contentBox = contentBox;
exports.noRepeat = noRepeat;
exports.space = space;
exports.repeat = repeat;
exports.minmax = minmax;
exports.repeatX = repeatX;
exports.repeatY = repeatY;
exports.contain = contain;
exports.cover = cover;
exports.row = row;
exports.rowReverse = rowReverse;
exports.column = column;
exports.columnReverse = columnReverse;
exports.wrap = wrap;
exports.nowrap = nowrap;
exports.wrapReverse = wrapReverse;
exports.inline = inline;
exports.block = block;
exports.contents = contents;
exports.flexBox = flexBox;
exports.grid = grid;
exports.inlineBlock = inlineBlock;
exports.inlineFlex = inlineFlex;
exports.inlineGrid = inlineGrid;
exports.inlineTable = inlineTable;
exports.listItem = listItem;
exports.runIn = runIn;
exports.table = table;
exports.tableCaption = tableCaption;
exports.tableColumnGroup = tableColumnGroup;
exports.tableHeaderGroup = tableHeaderGroup;
exports.tableFooterGroup = tableFooterGroup;
exports.tableRowGroup = tableRowGroup;
exports.tableCell = tableCell;
exports.tableColumn = tableColumn;
exports.tableRow = tableRow;
exports.flexStart = flexStart;
exports.flexEnd = flexEnd;
exports.center = center;
exports.stretch = stretch;
exports.spaceBetween = spaceBetween;
exports.spaceAround = spaceAround;
exports.spaceEvenly = spaceEvenly;
exports.baseline = baseline;
exports.forwards = forwards;
exports.backwards = backwards;
exports.both = both;
exports.infinite = infinite;
exports.count = count;
exports.paused = paused;
exports.running = running;
exports.inside = inside;
exports.outside = outside;
exports.solid = solid;
exports.dotted = dotted;
exports.dashed = dashed;
exports.underline = underline;
exports.overline = overline;
exports.lineThrough = lineThrough;
exports.clip = clip;
exports.ellipsis = ellipsis;
exports.wavy = wavy;
exports.$$double = $$double;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.sub = sub;
exports.$$super = $$super;
exports.textTop = textTop;
exports.textBottom = textBottom;
exports.middle = middle;
exports.normal = normal;
exports.breakAll = breakAll;
exports.keepAll = keepAll;
exports.breakWord = breakWord;
exports.reverse = reverse;
exports.alternate = alternate;
exports.alternateReverse = alternateReverse;
exports.fill = fill$2;
exports.content = content;
exports.maxContent = maxContent;
exports.minContent = minContent;
exports.fitContent = fitContent;
exports.all = all;
exports.round = round;
exports.miter = miter;
exports.bevel = bevel;
exports.butt = butt;
exports.square = square;
exports.thin = thin;
exports.extraLight = extraLight;
exports.light = light;
exports.medium = medium;
exports.semiBold = semiBold;
exports.bold = bold;
exports.extraBold = extraBold;
exports.lighter = lighter;
exports.bolder = bolder;
exports.fr = fr;
exports.vw = vw;
exports.localUrl = localUrl;
exports.url = url;
exports.linear = linear;
exports.ease = ease;
exports.easeIn = easeIn;
exports.easeOut = easeOut;
exports.easeInOut = easeInOut;
exports.stepStart = stepStart;
exports.stepEnd = stepEnd;
exports.steps = steps;
exports.cubicBezier = cubicBezier;
exports.marginBox = marginBox;
exports.fillBox = fillBox;
exports.strokeBox = strokeBox;
exports.viewBox = viewBox;
exports.translate = translate;
exports.translate3d = translate3d;
exports.translateX = translateX;
exports.translateY = translateY;
exports.translateZ = translateZ;
exports.scale = scale;
exports.scale3d = scale3d;
exports.scaleX = scaleX;
exports.scaleY = scaleY;
exports.scaleZ = scaleZ;
exports.rotate = rotate;
exports.rotate3d = rotate3d;
exports.rotateX = rotateX;
exports.rotateY = rotateY;
exports.rotateZ = rotateZ;
exports.skew = skew;
exports.skewX = skewX;
exports.skewY = skewY;
exports.linearGradient = linearGradient;
exports.repeatingLinearGradient = repeatingLinearGradient;
exports.radialGradient = radialGradient;
exports.repeatingRadialGradient = repeatingRadialGradient;
exports.areas = areas;
exports.ident = ident;
exports.numIdent = numIdent;
exports.contextMenu = contextMenu;
exports.help = help;
exports.pointer = pointer;
exports.progress = progress;
exports.wait = wait;
exports.cell = cell;
exports.crosshair = crosshair;
exports.verticalText = verticalText;
exports.alias = alias;
exports.copy = copy;
exports.move = move;
exports.noDrop = noDrop;
exports.notAllowed = notAllowed;
exports.grab = grab;
exports.grabbing = grabbing;
exports.allScroll = allScroll;
exports.colResize = colResize;
exports.rowResize = rowResize;
exports.nResize = nResize;
exports.eResize = eResize;
exports.sResize = sResize;
exports.wResize = wResize;
exports.neResize = neResize;
exports.nwResize = nwResize;
exports.seResize = seResize;
exports.swResize = swResize;
exports.ewResize = ewResize;
exports.nsResize = nsResize;
exports.neswResize = neswResize;
exports.nwseResize = nwseResize;
exports.zoomIn = zoomIn;
exports.zoomOut = zoomOut;
exports.flex3 = flex3;
exports.backgroundSize = backgroundSize;
exports.textDecoration = textDecoration;
exports.background = background;
exports.backgrounds = backgrounds;
exports.gridAutoColumns = gridAutoColumns;
exports.gridAutoRows = gridAutoRows;
exports.gridTemplateColumns = gridTemplateColumns;
exports.gridTemplateRows = gridTemplateRows;
exports.Calc = Calc;
exports.size = size;
exports.filter = filter;
exports.Transition = Transition;
exports.transitionValue = transitionValue;
exports.transitionList = transitionList;
exports.transition = transition;
exports.transitions = transitions;
exports.Animation = Animation;
exports.animationValue = animationValue;
exports.animation = animation;
exports.animations = animations;
exports.animationName = animationName;
exports.aliceblue = aliceblue;
exports.antiquewhite = antiquewhite;
exports.aqua = aqua;
exports.aquamarine = aquamarine;
exports.azure = azure;
exports.beige = beige;
exports.bisque = bisque;
exports.black = black;
exports.blanchedalmond = blanchedalmond;
exports.blue = blue;
exports.blueviolet = blueviolet;
exports.brown = brown;
exports.burlywood = burlywood;
exports.cadetblue = cadetblue;
exports.chartreuse = chartreuse;
exports.chocolate = chocolate;
exports.coral = coral;
exports.cornflowerblue = cornflowerblue;
exports.cornsilk = cornsilk;
exports.crimson = crimson;
exports.cyan = cyan;
exports.darkblue = darkblue;
exports.darkcyan = darkcyan;
exports.darkgoldenrod = darkgoldenrod;
exports.darkgray = darkgray;
exports.darkgrey = darkgrey;
exports.darkgreen = darkgreen;
exports.darkkhaki = darkkhaki;
exports.darkmagenta = darkmagenta;
exports.darkolivegreen = darkolivegreen;
exports.darkorange = darkorange;
exports.darkorchid = darkorchid;
exports.darkred = darkred;
exports.darksalmon = darksalmon;
exports.darkseagreen = darkseagreen;
exports.darkslateblue = darkslateblue;
exports.darkslategray = darkslategray;
exports.darkslategrey = darkslategrey;
exports.darkturquoise = darkturquoise;
exports.darkviolet = darkviolet;
exports.deeppink = deeppink;
exports.deepskyblue = deepskyblue;
exports.dimgray = dimgray;
exports.dimgrey = dimgrey;
exports.dodgerblue = dodgerblue;
exports.firebrick = firebrick;
exports.floralwhite = floralwhite;
exports.forestgreen = forestgreen;
exports.fuchsia = fuchsia;
exports.gainsboro = gainsboro;
exports.ghostwhite = ghostwhite;
exports.gold = gold;
exports.goldenrod = goldenrod;
exports.gray = gray;
exports.grey = grey;
exports.green = green;
exports.greenyellow = greenyellow;
exports.honeydew = honeydew;
exports.hotpink = hotpink;
exports.indianred = indianred;
exports.indigo = indigo;
exports.ivory = ivory;
exports.khaki = khaki;
exports.lavender = lavender;
exports.lavenderblush = lavenderblush;
exports.lawngreen = lawngreen;
exports.lemonchiffon = lemonchiffon;
exports.lightblue = lightblue;
exports.lightcoral = lightcoral;
exports.lightcyan = lightcyan;
exports.lightgoldenrodyellow = lightgoldenrodyellow;
exports.lightgray = lightgray;
exports.lightgrey = lightgrey;
exports.lightgreen = lightgreen;
exports.lightpink = lightpink;
exports.lightsalmon = lightsalmon;
exports.lightseagreen = lightseagreen;
exports.lightskyblue = lightskyblue;
exports.lightslategray = lightslategray;
exports.lightslategrey = lightslategrey;
exports.lightsteelblue = lightsteelblue;
exports.lightyellow = lightyellow;
exports.lime = lime;
exports.limegreen = limegreen;
exports.linen = linen;
exports.magenta = magenta;
exports.maroon = maroon;
exports.mediumaquamarine = mediumaquamarine;
exports.mediumblue = mediumblue;
exports.mediumorchid = mediumorchid;
exports.mediumpurple = mediumpurple;
exports.mediumseagreen = mediumseagreen;
exports.mediumslateblue = mediumslateblue;
exports.mediumspringgreen = mediumspringgreen;
exports.mediumturquoise = mediumturquoise;
exports.mediumvioletred = mediumvioletred;
exports.midnightblue = midnightblue;
exports.mintcream = mintcream;
exports.mistyrose = mistyrose;
exports.moccasin = moccasin;
exports.navajowhite = navajowhite;
exports.navy = navy;
exports.oldlace = oldlace;
exports.olive = olive;
exports.olivedrab = olivedrab;
exports.orange = orange;
exports.orangered = orangered;
exports.orchid = orchid;
exports.palegoldenrod = palegoldenrod;
exports.palegreen = palegreen;
exports.paleturquoise = paleturquoise;
exports.palevioletred = palevioletred;
exports.papayawhip = papayawhip;
exports.peachpuff = peachpuff;
exports.peru = peru;
exports.pink = pink;
exports.plum = plum;
exports.powderblue = powderblue;
exports.purple = purple;
exports.rebeccapurple = rebeccapurple;
exports.red = red;
exports.rosybrown = rosybrown;
exports.royalblue = royalblue;
exports.saddlebrown = saddlebrown;
exports.salmon = salmon;
exports.sandybrown = sandybrown;
exports.seagreen = seagreen;
exports.seashell = seashell;
exports.sienna = sienna;
exports.silver = silver;
exports.skyblue = skyblue;
exports.slateblue = slateblue;
exports.slategray = slategray;
exports.slategrey = slategrey;
exports.snow = snow;
exports.springgreen = springgreen;
exports.steelblue = steelblue;
exports.tan = tan;
exports.teal = teal;
exports.thistle = thistle;
exports.tomato = tomato;
exports.turquoise = turquoise;
exports.violet = violet;
exports.wheat = wheat;
exports.white = white;
exports.whitesmoke = whitesmoke;
exports.yellow = yellow;
exports.yellowgreen = yellowgreen;
exports.$$global = $$global;
exports.insertRule = insertRule;
exports.merge = merge;
exports.style = style;
exports.keyframes = keyframes;
exports.fontFace = fontFace;
exports.Point = Point;
exports.Theme = Theme;
exports.Box = Box;
exports.Utils = Utils;
exports.Typography = Typography;
exports.Elevation = Elevation;
exports.Color = Color;
exports.Spacing = Spacing;
exports.Icon = Icon;
exports.$$Image = $$Image;
exports.Button = Button;
exports.Input = Input;
exports.withFont = withFont;
exports.inheritFont = inheritFont;
exports.texturedBackground = texturedBackground;
exports.texturedDarkBackground = texturedDarkBackground;
exports.mobileMedia = mobileMedia;
exports.SVG = SVG;
exports.backgroundColor = backgroundColor;
exports.borderBottom = borderBottom;
exports.borderBottomColor = borderBottomColor;
exports.border = border;
exports.borderColor = borderColor;
exports.borderLeft = borderLeft;
exports.borderLeftColor = borderLeftColor;
exports.borderRight = borderRight;
exports.borderRightColor = borderRightColor;
exports.borderTop = borderTop;
exports.borderTopColor = borderTopColor;
exports.color = color;
exports.outline = outline;
exports.textDecorationColor = textDecorationColor;
exports.removeBoxShadow = removeBoxShadow;
exports.boxShadow = boxShadow;
exports.fontWeight = fontWeight;
exports.fontFamily = fontFamily;
exports.fontFamilies = fontFamilies;
exports.fontSize = fontSize;
exports.lineHeight = lineHeight;
exports.boxShadows = boxShadows;
/* toRemValue Not a pure module */
